import { getCurrentInstance as te, inject as me, ref as j, computed as w2, watch as $2, onMounted as b0, onUnmounted as Ce, createVNode as o2, Text as I0, defineComponent as ne, createElementBlock as W, openBlock as V, toRef as O0, useSlots as pe, onBeforeMount as ge, nextTick as he, onBeforeUnmount as Ae, resolveDirective as ve, normalizeClass as t2, createElementVNode as T, unref as O, renderSlot as Y2, createCommentVNode as c2, withModifiers as f2, Fragment as E2, renderList as H2, toDisplayString as p2, Transition as j2, withCtx as q2, withDirectives as T2, vShow as X2, withKeys as E0, vModelText as H0, createBlock as be, normalizeStyle as Le } from "vue";
var ke = /* @__PURE__ */ ((e) => (e.Y = "Y", e.N = "N", e))(ke || {}), y2 = /* @__PURE__ */ ((e) => (e.LOCAL = "local", e.DEV = "development", e.STAGE = "staging", e.DEMO = "demo", e.PROD = "production", e))(y2 || {}), b = /* @__PURE__ */ ((e) => (e.APOC = "APOC", e.PLAY = "PLAY", e.STUDIO = "STUDIO", e.ASSET = "ASSET", e.COMM = "COMM", e.SSO = "SSO", e.MY = "MY", e))(b || {}), L0 = /* @__PURE__ */ ((e) => (e.LEFT = "LEFT", e.RIGHT = "RIGHT", e))(L0 || {}), ae = /* @__PURE__ */ ((e) => (e.LIGHT = "LIGHT", e.DARK = "DARK", e))(ae || {}), e0 = /* @__PURE__ */ ((e) => (e.KO = "ko", e.EN = "en", e))(e0 || {});
const T0 = [
  {
    code: e0.KO,
    label: "lang.ko",
    subLabel: "KR"
  },
  {
    code: e0.EN,
    label: "lang.en",
    subLabel: "EN"
  }
], P2 = {
  env: y2.LOCAL,
  serviceType: b.PLAY,
  apocHost: "https://brand.apoc.day/",
  playHost: "https://dev.apoc.day/",
  studioHost: "https://studio-dev.apoc.day/#/",
  assetHost: "https://asset-dev.apoc.day/",
  commHost: "https://community-dev.apoc.day/",
  sideBarLocation: L0.LEFT,
  theme: ae.LIGHT,
  lang: e0.EN
}, d0 = [
  {
    serviceCode: b.APOC,
    serviceName: "megaMenu.apoc",
    serviceUrl: P2.apocHost,
    subMenuList: []
  },
  {
    serviceCode: b.PLAY,
    serviceName: "megaMenu.play",
    serviceUrl: P2.playHost,
    subMenuList: []
  },
  {
    serviceCode: b.STUDIO,
    serviceName: "megaMenu.studio",
    serviceUrl: P2.studioHost,
    subMenuList: [
      {
        subMenuCode: "main",
        subMenuName: "megaMenu.studioList.home",
        subMenuPath: ""
      },
      {
        subMenuCode: "pricing",
        subMenuName: "megaMenu.studioList.pricing",
        subMenuPath: "price"
      }
    ]
  },
  {
    serviceCode: b.ASSET,
    serviceName: "megaMenu.asset",
    serviceUrl: P2.assetHost,
    subMenuList: [
      {
        subMenuCode: "icon 3D",
        subMenuName: "megaMenu.assetList.icon3d",
        subMenuPath: "asset-menu/3d_sticker"
      },
      {
        subMenuCode: "relity 3D",
        subMenuName: "megaMenu.assetList.reality3d",
        subMenuPath: "asset-menu/reality_3d"
      },
      {
        subMenuCode: "made 3D",
        subMenuName: "megaMenu.assetList.made3d",
        subMenuPath: "asset-menu/made_3d"
      },
      {
        subMenuCode: "background",
        subMenuName: "megaMenu.assetList.background",
        subMenuPath: "asset-menu/backgroud"
      },
      {
        subMenuCode: "subscribe",
        subMenuName: "megaMenu.assetList.pricing",
        subMenuPath: "subscribe"
      }
    ]
  },
  {
    serviceCode: b.COMM,
    serviceName: "megaMenu.comm",
    serviceUrl: P2.commHost,
    subMenuList: [
      {
        subMenuCode: "apocNews",
        subMenuName: "megaMenu.commList.apocNews",
        subMenuPath: "board/apoc_news?type=NOW"
      },
      {
        subMenuCode: "tutorial",
        subMenuName: "megaMenu.commList.howToUse",
        subMenuPath: "board/tutorial?type=MANUAL"
      },
      {
        subMenuCode: "board",
        subMenuName: "megaMenu.commList.board",
        subMenuPath: "board/board?type=FREE"
      },
      {
        subMenuCode: "notice",
        subMenuName: "megaMenu.commList.notice",
        subMenuPath: "board/notice?type=NOTICE"
      }
    ]
  }
];
/*!
  * @intlify/shared v9.0.0
  * (c) 2021 kazuya kawaguchi
  * Released under the MIT License.
  */
const M2 = typeof window < "u";
let _, S2;
if (process.env.NODE_ENV !== "production") {
  const e = M2 && window.performance;
  e && e.mark && e.measure && e.clearMarks && e.clearMeasures && (_ = (t) => e.mark(t), S2 = (t, a, n) => {
    e.measure(t, a, n), e.clearMarks(a), e.clearMarks(n);
  });
}
const we = /\{([0-9a-zA-Z]+)\}/g;
function r0(e, ...t) {
  return t.length === 1 && r2(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(we, (a, n) => t.hasOwnProperty(n) ? t[n] : "");
}
const ye = typeof Symbol == "function" && typeof Symbol.toStringTag == "symbol", U2 = (e) => ye ? Symbol(e) : e, Me = (e, t, a) => Se({ l: e, k: t, s: a }), Se = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), z = (e) => typeof e == "number" && isFinite(e), Fe = (e) => k0(e) === "[object Date]", t0 = (e) => k0(e) === "[object RegExp]", l0 = (e) => U(e) && Object.keys(e).length === 0;
function K2(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
let N0;
const _2 = () => N0 || (N0 = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function P0(e) {
  return e.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const X = Array.isArray, q = (e) => typeof e == "function", R = (e) => typeof e == "string", J = (e) => typeof e == "boolean", r2 = (e) => (
  // eslint-disable-line
  e !== null && typeof e == "object"
), se = Object.prototype.toString, k0 = (e) => se.call(e), U = (e) => k0(e) === "[object Object]", Ie = (e) => e == null ? "" : X(e) || U(e) && e.toString === se ? JSON.stringify(e, null, 2) : String(e), R0 = 2;
function Oe(e, t = 0, a = e.length) {
  const n = e.split(/\r?\n/);
  let r = 0;
  const s = [];
  for (let u = 0; u < n.length; u++)
    if (r += n[u].length + 1, r >= t) {
      for (let i = u - R0; i <= u + R0 || a > r; i++) {
        if (i < 0 || i >= n.length)
          continue;
        const C = i + 1;
        s.push(`${C}${" ".repeat(3 - String(C).length)}|  ${n[i]}`);
        const h = n[i].length;
        if (i === u) {
          const w = t - (r - h) + 1, M = Math.max(1, a > r ? h - w : a - t);
          s.push("   |  " + " ".repeat(w) + "^".repeat(M));
        } else if (i > u) {
          if (a > r) {
            const w = Math.max(Math.min(a - r, h), 1);
            s.push("   |  " + "^".repeat(w));
          }
          r += h + 1;
        }
      }
      break;
    }
  return s.join(`
`);
}
/*!
  * @intlify/message-resolver v9.0.0
  * (c) 2021 kazuya kawaguchi
  * Released under the MIT License.
  */
process.env.NODE_ENV;
const Ee = (e) => (
  // eslint-disable-line
  e !== null && typeof e == "object"
), h2 = [];
h2[
  0
  /* BEFORE_PATH */
] = {
  w: [
    0
    /* BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* APPEND */
  ],
  "[": [
    4
    /* IN_SUB_PATH */
  ],
  o: [
    7
    /* AFTER_PATH */
  ]
};
h2[
  1
  /* IN_PATH */
] = {
  w: [
    1
    /* IN_PATH */
  ],
  ".": [
    2
    /* BEFORE_IDENT */
  ],
  "[": [
    4
    /* IN_SUB_PATH */
  ],
  o: [
    7
    /* AFTER_PATH */
  ]
};
h2[
  2
  /* BEFORE_IDENT */
] = {
  w: [
    2
    /* BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* APPEND */
  ],
  0: [
    3,
    0
    /* APPEND */
  ]
};
h2[
  3
  /* IN_IDENT */
] = {
  i: [
    3,
    0
    /* APPEND */
  ],
  0: [
    3,
    0
    /* APPEND */
  ],
  w: [
    1,
    1
    /* PUSH */
  ],
  ".": [
    2,
    1
    /* PUSH */
  ],
  "[": [
    4,
    1
    /* PUSH */
  ],
  o: [
    7,
    1
    /* PUSH */
  ]
};
h2[
  4
  /* IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* APPEND */
  ],
  '"': [
    6,
    0
    /* APPEND */
  ],
  "[": [
    4,
    2
    /* INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* APPEND */
  ]
};
h2[
  5
  /* IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* APPEND */
  ]
};
h2[
  6
  /* IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* APPEND */
  ]
};
const He = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function Te(e) {
  return He.test(e);
}
function Ne(e) {
  const t = e.charCodeAt(0), a = e.charCodeAt(e.length - 1);
  return t === a && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function Pe(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    // [
    case 93:
    // ]
    case 46:
    // .
    case 34:
    // "
    case 39:
      return e;
    case 95:
    // _
    case 36:
    // $
    case 45:
      return "i";
    case 9:
    // Tab (HT)
    case 10:
    // Newline (LF)
    case 13:
    // Return (CR)
    case 160:
    // No-break space (NBSP)
    case 65279:
    // Byte Order Mark (BOM)
    case 8232:
    // Line Separator (LS)
    case 8233:
      return "w";
  }
  return "i";
}
function Re(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : Te(t) ? Ne(t) : "*" + t;
}
function Ve(e) {
  const t = [];
  let a = -1, n = 0, r = 0, s, u, i, C, h, w, M;
  const v = [];
  v[
    0
    /* APPEND */
  ] = () => {
    u === void 0 ? u = i : u += i;
  }, v[
    1
    /* PUSH */
  ] = () => {
    u !== void 0 && (t.push(u), u = void 0);
  }, v[
    2
    /* INC_SUB_PATH_DEPTH */
  ] = () => {
    v[
      0
      /* APPEND */
    ](), r++;
  }, v[
    3
    /* PUSH_SUB_PATH */
  ] = () => {
    if (r > 0)
      r--, n = 4, v[
        0
        /* APPEND */
      ]();
    else {
      if (r = 0, u === void 0 || (u = Re(u), u === !1))
        return !1;
      v[
        1
        /* PUSH */
      ]();
    }
  };
  function B() {
    const L = e[a + 1];
    if (n === 5 && L === "'" || n === 6 && L === '"')
      return a++, i = "\\" + L, v[
        0
        /* APPEND */
      ](), !0;
  }
  for (; n !== null; )
    if (a++, s = e[a], !(s === "\\" && B())) {
      if (C = Pe(s), M = h2[n], h = M[C] || M.l || 8, h === 8 || (n = h[0], h[1] !== void 0 && (w = v[h[1]], w && (i = s, w() === !1))))
        return;
      if (n === 7)
        return t;
    }
}
const V0 = /* @__PURE__ */ new Map();
function n0(e, t) {
  if (!Ee(e))
    return null;
  let a = V0.get(t);
  if (a || (a = Ve(t), a && V0.set(t, a)), !a)
    return null;
  const n = a.length;
  let r = e, s = 0;
  for (; s < n; ) {
    const u = r[a[s]];
    if (u === void 0)
      return null;
    r = u, s++;
  }
  return r;
}
/*!
  * @intlify/runtime v9.0.0
  * (c) 2021 kazuya kawaguchi
  * Released under the MIT License.
  */
const We = (e) => e, Be = (e) => "", Ue = "text", De = (e) => e.length === 0 ? "" : e.join(""), Ze = Ie;
function W0(e, t) {
  return e = Math.abs(e), t === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function xe(e) {
  const t = z(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && (z(e.named.count) || z(e.named.n)) ? z(e.named.count) ? e.named.count : z(e.named.n) ? e.named.n : t : t;
}
function Qe(e, t) {
  t.count || (t.count = e), t.n || (t.n = e);
}
function Ke(e = {}) {
  const t = e.locale, a = xe(e), n = r2(e.pluralRules) && R(t) && q(e.pluralRules[t]) ? e.pluralRules[t] : W0, r = r2(e.pluralRules) && R(t) && q(e.pluralRules[t]) ? W0 : void 0, s = (y) => y[n(a, y.length, r)], u = e.list || [], i = (y) => u[y], C = e.named || {};
  z(e.pluralIndex) && Qe(a, C);
  const h = (y) => C[y];
  function w(y) {
    const c = q(e.messages) ? e.messages(y) : r2(e.messages) ? e.messages[y] : !1;
    return c || (e.parent ? e.parent.message(y) : Be);
  }
  const M = (y) => e.modifiers ? e.modifiers[y] : We, v = U(e.processor) && q(e.processor.normalize) ? e.processor.normalize : De, B = U(e.processor) && q(e.processor.interpolate) ? e.processor.interpolate : Ze, L = U(e.processor) && R(e.processor.type) ? e.processor.type : Ue, I = {
    list: i,
    named: h,
    plural: s,
    linked: (y, c) => {
      const g = w(y)(I);
      return R(c) ? M(c)(g) : g;
    },
    message: w,
    type: L,
    interpolate: B,
    normalize: v
  };
  return I;
}
/*!
  * @intlify/message-compiler v9.0.0
  * (c) 2021 kazuya kawaguchi
  * Released under the MIT License.
  */
const Je = {
  // tokenizer error messages
  0: "Expected token: '{0}'",
  1: "Invalid token in placeholder: '{0}'",
  2: "Unterminated single quote in placeholder",
  3: "Unknown escape sequence: \\{0}",
  4: "Invalid unicode escape sequence: {0}",
  5: "Unbalanced closing brace",
  6: "Unterminated closing brace",
  7: "Empty placeholder",
  8: "Not allowed nest placeholder",
  9: "Invalid linked format",
  // parser error messages
  10: "Plural must have messages",
  11: "Unexpected empty linked modifier",
  12: "Unexpected empty linked key",
  13: "Unexpected lexical analysis in token: '{0}'"
};
function c0(e, t, a = {}) {
  const { domain: n, messages: r, args: s } = a, u = process.env.NODE_ENV !== "production" ? r0((r || Je)[e] || "", ...s || []) : e, i = new SyntaxError(String(u));
  return i.code = e, t && (i.location = t), i.domain = n, i;
}
function Ge(e) {
  throw e;
}
function Ye(e, t, a) {
  return { line: e, column: t, offset: a };
}
function m0(e, t, a) {
  return { start: e, end: t };
}
const m2 = " ", je = "\r", Y = `
`, qe = "\u2028", Xe = "\u2029";
function ze(e) {
  const t = e;
  let a = 0, n = 1, r = 1, s = 0;
  const u = (E) => t[E] === je && t[E + 1] === Y, i = (E) => t[E] === Y, C = (E) => t[E] === Xe, h = (E) => t[E] === qe, w = (E) => u(E) || i(E) || C(E) || h(E), M = () => a, v = () => n, B = () => r, L = () => s, I = (E) => u(E) || C(E) || h(E) ? Y : t[E], y = () => I(a), c = () => I(a + s);
  function g() {
    return s = 0, w(a) && (n++, r = 0), u(a) && a++, a++, r++, t[a];
  }
  function A() {
    return u(a + s) && s++, s++, t[a + s];
  }
  function f() {
    a = 0, n = 1, r = 1, s = 0;
  }
  function F(E = 0) {
    s = E;
  }
  function S() {
    const E = a + s;
    for (; E !== a; )
      g();
    s = 0;
  }
  return {
    index: M,
    line: v,
    column: B,
    peekOffset: L,
    charAt: I,
    currentChar: y,
    currentPeek: c,
    next: g,
    peek: A,
    reset: f,
    resetPeek: F,
    skipToPeek: S
  };
}
const g2 = void 0, B0 = "'", _e = "tokenizer";
function $e(e, t = {}) {
  const a = t.location !== !1, n = ze(e), r = () => n.index(), s = () => Ye(n.line(), n.column(), n.index()), u = s(), i = r(), C = {
    currentType: 14,
    offset: i,
    startLoc: u,
    endLoc: u,
    lastType: 14,
    lastOffset: i,
    lastStartLoc: u,
    lastEndLoc: u,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, h = () => C, { onError: w } = t;
  function M(o, l, d, ...p) {
    const H = h();
    if (l.column += d, l.offset += d, w) {
      const D = m0(H.startLoc, l), e2 = c0(o, D, {
        domain: _e,
        args: p
      });
      w(e2);
    }
  }
  function v(o, l, d) {
    o.endLoc = s(), o.currentType = l;
    const p = { type: l };
    return a && (p.loc = m0(o.startLoc, o.endLoc)), d != null && (p.value = d), p;
  }
  const B = (o) => v(
    o,
    14
    /* EOF */
  );
  function L(o, l) {
    return o.currentChar() === l ? (o.next(), l) : (M(0, s(), 0, l), "");
  }
  function I(o) {
    let l = "";
    for (; o.currentPeek() === m2 || o.currentPeek() === Y; )
      l += o.currentPeek(), o.peek();
    return l;
  }
  function y(o) {
    const l = I(o);
    return o.skipToPeek(), l;
  }
  function c(o) {
    if (o === g2)
      return !1;
    const l = o.charCodeAt(0);
    return l >= 97 && l <= 122 || // a-z
    l >= 65 && l <= 90;
  }
  function g(o) {
    if (o === g2)
      return !1;
    const l = o.charCodeAt(0);
    return l >= 48 && l <= 57;
  }
  function A(o, l) {
    const { currentType: d } = l;
    if (d !== 2)
      return !1;
    I(o);
    const p = c(o.currentPeek());
    return o.resetPeek(), p;
  }
  function f(o, l) {
    const { currentType: d } = l;
    if (d !== 2)
      return !1;
    I(o);
    const p = o.currentPeek() === "-" ? o.peek() : o.currentPeek(), H = g(p);
    return o.resetPeek(), H;
  }
  function F(o, l) {
    const { currentType: d } = l;
    if (d !== 2)
      return !1;
    I(o);
    const p = o.currentPeek() === B0;
    return o.resetPeek(), p;
  }
  function S(o, l) {
    const { currentType: d } = l;
    if (d !== 8)
      return !1;
    I(o);
    const p = o.currentPeek() === ".";
    return o.resetPeek(), p;
  }
  function E(o, l) {
    const { currentType: d } = l;
    if (d !== 9)
      return !1;
    I(o);
    const p = c(o.currentPeek());
    return o.resetPeek(), p;
  }
  function K(o, l) {
    const { currentType: d } = l;
    if (!(d === 8 || d === 12))
      return !1;
    I(o);
    const p = o.currentPeek() === ":";
    return o.resetPeek(), p;
  }
  function x(o, l) {
    const { currentType: d } = l;
    if (d !== 10)
      return !1;
    const p = () => {
      const D = o.currentPeek();
      return D === "{" ? c(o.peek()) : D === "@" || D === "%" || D === "|" || D === ":" || D === "." || D === m2 || !D ? !1 : D === Y ? (o.peek(), p()) : c(D);
    }, H = p();
    return o.resetPeek(), H;
  }
  function n2(o) {
    I(o);
    const l = o.currentPeek() === "|";
    return o.resetPeek(), l;
  }
  function A2(o, l = !0) {
    const d = (H = !1, D = "", e2 = !1) => {
      const m = o.currentPeek();
      return m === "{" ? D === "%" ? !1 : H : m === "@" || !m ? D === "%" ? !0 : H : m === "%" ? (o.peek(), d(H, "%", !0)) : m === "|" ? D === "%" || e2 ? !0 : !(D === m2 || D === Y) : m === m2 ? (o.peek(), d(!0, m2, e2)) : m === Y ? (o.peek(), d(!0, Y, e2)) : !0;
    }, p = d();
    return l && o.resetPeek(), p;
  }
  function u2(o, l) {
    const d = o.currentChar();
    return d === g2 ? g2 : l(d) ? (o.next(), d) : null;
  }
  function F2(o) {
    return u2(o, (d) => {
      const p = d.charCodeAt(0);
      return p >= 97 && p <= 122 || // a-z
      p >= 65 && p <= 90 || // A-Z
      p >= 48 && p <= 57 || // 0-9
      p === 95 || p === 36;
    });
  }
  function I2(o) {
    return u2(o, (d) => {
      const p = d.charCodeAt(0);
      return p >= 48 && p <= 57;
    });
  }
  function $(o) {
    return u2(o, (d) => {
      const p = d.charCodeAt(0);
      return p >= 48 && p <= 57 || // 0-9
      p >= 65 && p <= 70 || // A-F
      p >= 97 && p <= 102;
    });
  }
  function v2(o) {
    let l = "", d = "";
    for (; l = I2(o); )
      d += l;
    return d;
  }
  function b2(o) {
    const l = (d) => {
      const p = o.currentChar();
      return p === "{" || p === "}" || p === "@" || !p ? d : p === "%" ? A2(o) ? (d += p, o.next(), l(d)) : d : p === "|" ? d : p === m2 || p === Y ? A2(o) ? (d += p, o.next(), l(d)) : n2(o) ? d : (d += p, o.next(), l(d)) : (d += p, o.next(), l(d));
    };
    return l("");
  }
  function a2(o) {
    y(o);
    let l = "", d = "";
    for (; l = F2(o); )
      d += l;
    return o.currentChar() === g2 && M(6, s(), 0), d;
  }
  function D2(o) {
    y(o);
    let l = "";
    return o.currentChar() === "-" ? (o.next(), l += `-${v2(o)}`) : l += v2(o), o.currentChar() === g2 && M(6, s(), 0), l;
  }
  function Z2(o) {
    y(o), L(o, "'");
    let l = "", d = "";
    const p = (D) => D !== B0 && D !== Y;
    for (; l = u2(o, p); )
      l === "\\" ? d += x2(o) : d += l;
    const H = o.currentChar();
    return H === Y || H === g2 ? (M(2, s(), 0), H === Y && (o.next(), L(o, "'")), d) : (L(o, "'"), d);
  }
  function x2(o) {
    const l = o.currentChar();
    switch (l) {
      case "\\":
      case "'":
        return o.next(), `\\${l}`;
      case "u":
        return L2(o, l, 4);
      case "U":
        return L2(o, l, 6);
      default:
        return M(3, s(), 0, l), "";
    }
  }
  function L2(o, l, d) {
    L(o, l);
    let p = "";
    for (let H = 0; H < d; H++) {
      const D = $(o);
      if (!D) {
        M(4, s(), 0, `\\${l}${p}${o.currentChar()}`);
        break;
      }
      p += D;
    }
    return `\\${l}${p}`;
  }
  function d2(o) {
    y(o);
    let l = "", d = "";
    const p = (H) => H !== "{" && H !== "}" && H !== m2 && H !== Y;
    for (; l = u2(o, p); )
      d += l;
    return d;
  }
  function l2(o) {
    let l = "", d = "";
    for (; l = F2(o); )
      d += l;
    return d;
  }
  function O2(o) {
    const l = (d = !1, p) => {
      const H = o.currentChar();
      return H === "{" || H === "%" || H === "@" || H === "|" || !H || H === m2 ? p : H === Y ? (p += H, o.next(), l(d, p)) : (p += H, o.next(), l(!0, p));
    };
    return l(!1, "");
  }
  function N(o) {
    y(o);
    const l = L(
      o,
      "|"
      /* Pipe */
    );
    return y(o), l;
  }
  function P(o, l) {
    let d = null;
    switch (o.currentChar()) {
      case "{":
        return l.braceNest >= 1 && M(8, s(), 0), o.next(), d = v(
          l,
          2,
          "{"
          /* BraceLeft */
        ), y(o), l.braceNest++, d;
      case "}":
        return l.braceNest > 0 && l.currentType === 2 && M(7, s(), 0), o.next(), d = v(
          l,
          3,
          "}"
          /* BraceRight */
        ), l.braceNest--, l.braceNest > 0 && y(o), l.inLinked && l.braceNest === 0 && (l.inLinked = !1), d;
      case "@":
        return l.braceNest > 0 && M(6, s(), 0), d = Z(o, l) || B(l), l.braceNest = 0, d;
      default:
        let H = !0, D = !0, e2 = !0;
        if (n2(o))
          return l.braceNest > 0 && M(6, s(), 0), d = v(l, 1, N(o)), l.braceNest = 0, l.inLinked = !1, d;
        if (l.braceNest > 0 && (l.currentType === 5 || l.currentType === 6 || l.currentType === 7))
          return M(6, s(), 0), l.braceNest = 0, G(o, l);
        if (H = A(o, l))
          return d = v(l, 5, a2(o)), y(o), d;
        if (D = f(o, l))
          return d = v(l, 6, D2(o)), y(o), d;
        if (e2 = F(o, l))
          return d = v(l, 7, Z2(o)), y(o), d;
        if (!H && !D && !e2)
          return d = v(l, 13, d2(o)), M(1, s(), 0, d.value), y(o), d;
        break;
    }
    return d;
  }
  function Z(o, l) {
    const { currentType: d } = l;
    let p = null;
    const H = o.currentChar();
    switch ((d === 8 || d === 9 || d === 12 || d === 10) && (H === Y || H === m2) && M(9, s(), 0), H) {
      case "@":
        return o.next(), p = v(
          l,
          8,
          "@"
          /* LinkedAlias */
        ), l.inLinked = !0, p;
      case ".":
        return y(o), o.next(), v(
          l,
          9,
          "."
          /* LinkedDot */
        );
      case ":":
        return y(o), o.next(), v(
          l,
          10,
          ":"
          /* LinkedDelimiter */
        );
      default:
        return n2(o) ? (p = v(l, 1, N(o)), l.braceNest = 0, l.inLinked = !1, p) : S(o, l) || K(o, l) ? (y(o), Z(o, l)) : E(o, l) ? (y(o), v(l, 12, l2(o))) : x(o, l) ? (y(o), H === "{" ? P(o, l) || p : v(l, 11, O2(o))) : (d === 8 && M(9, s(), 0), l.braceNest = 0, l.inLinked = !1, G(o, l));
    }
  }
  function G(o, l) {
    let d = {
      type: 14
      /* EOF */
    };
    if (l.braceNest > 0)
      return P(o, l) || B(l);
    if (l.inLinked)
      return Z(o, l) || B(l);
    const p = o.currentChar();
    switch (p) {
      case "{":
        return P(o, l) || B(l);
      case "}":
        return M(5, s(), 0), o.next(), v(
          l,
          3,
          "}"
          /* BraceRight */
        );
      case "@":
        return Z(o, l) || B(l);
      default:
        if (n2(o))
          return d = v(l, 1, N(o)), l.braceNest = 0, l.inLinked = !1, d;
        if (A2(o))
          return v(l, 0, b2(o));
        if (p === "%")
          return o.next(), v(
            l,
            4,
            "%"
            /* Modulo */
          );
        break;
    }
    return d;
  }
  function C2() {
    const { currentType: o, offset: l, startLoc: d, endLoc: p } = C;
    return C.lastType = o, C.lastOffset = l, C.lastStartLoc = d, C.lastEndLoc = p, C.offset = r(), C.startLoc = s(), n.currentChar() === g2 ? v(
      C,
      14
      /* EOF */
    ) : G(n, C);
  }
  return {
    nextToken: C2,
    currentOffset: r,
    currentPosition: s,
    context: h
  };
}
const e1 = "parser", t1 = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function n1(e, t, a) {
  switch (e) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const n = parseInt(t || a, 16);
      return n <= 55295 || n >= 57344 ? String.fromCodePoint(n) : "�";
    }
  }
}
function a1(e = {}) {
  const t = e.location !== !1, { onError: a } = e;
  function n(c, g, A, f, ...F) {
    const S = c.currentPosition();
    if (S.offset += f, S.column += f, a) {
      const E = m0(A, S), K = c0(g, E, {
        domain: e1,
        args: F
      });
      a(K);
    }
  }
  function r(c, g, A) {
    const f = {
      type: c,
      start: g,
      end: g
    };
    return t && (f.loc = { start: A, end: A }), f;
  }
  function s(c, g, A, f) {
    c.end = g, t && c.loc && (c.loc.end = A);
  }
  function u(c, g) {
    const A = c.context(), f = r(3, A.offset, A.startLoc);
    return f.value = g, s(f, c.currentOffset(), c.currentPosition()), f;
  }
  function i(c, g) {
    const A = c.context(), { lastOffset: f, lastStartLoc: F } = A, S = r(5, f, F);
    return S.index = parseInt(g, 10), c.nextToken(), s(S, c.currentOffset(), c.currentPosition()), S;
  }
  function C(c, g) {
    const A = c.context(), { lastOffset: f, lastStartLoc: F } = A, S = r(4, f, F);
    return S.key = g, c.nextToken(), s(S, c.currentOffset(), c.currentPosition()), S;
  }
  function h(c, g) {
    const A = c.context(), { lastOffset: f, lastStartLoc: F } = A, S = r(9, f, F);
    return S.value = g.replace(t1, n1), c.nextToken(), s(S, c.currentOffset(), c.currentPosition()), S;
  }
  function w(c) {
    const g = c.nextToken(), A = c.context(), { lastOffset: f, lastStartLoc: F } = A, S = r(8, f, F);
    return g.type !== 12 ? (n(c, 11, A.lastStartLoc, 0), S.value = "", s(S, f, F), {
      nextConsumeToken: g,
      node: S
    }) : (g.value == null && n(c, 13, A.lastStartLoc, 0, i2(g)), S.value = g.value || "", s(S, c.currentOffset(), c.currentPosition()), {
      node: S
    });
  }
  function M(c, g) {
    const A = c.context(), f = r(7, A.offset, A.startLoc);
    return f.value = g, s(f, c.currentOffset(), c.currentPosition()), f;
  }
  function v(c) {
    const g = c.context(), A = r(6, g.offset, g.startLoc);
    let f = c.nextToken();
    if (f.type === 9) {
      const F = w(c);
      A.modifier = F.node, f = F.nextConsumeToken || c.nextToken();
    }
    switch (f.type !== 10 && n(c, 13, g.lastStartLoc, 0, i2(f)), f = c.nextToken(), f.type === 2 && (f = c.nextToken()), f.type) {
      case 11:
        f.value == null && n(c, 13, g.lastStartLoc, 0, i2(f)), A.key = M(c, f.value || "");
        break;
      case 5:
        f.value == null && n(c, 13, g.lastStartLoc, 0, i2(f)), A.key = C(c, f.value || "");
        break;
      case 6:
        f.value == null && n(c, 13, g.lastStartLoc, 0, i2(f)), A.key = i(c, f.value || "");
        break;
      case 7:
        f.value == null && n(c, 13, g.lastStartLoc, 0, i2(f)), A.key = h(c, f.value || "");
        break;
      default:
        n(c, 12, g.lastStartLoc, 0);
        const F = c.context(), S = r(7, F.offset, F.startLoc);
        return S.value = "", s(S, F.offset, F.startLoc), A.key = S, s(A, F.offset, F.startLoc), {
          nextConsumeToken: f,
          node: A
        };
    }
    return s(A, c.currentOffset(), c.currentPosition()), {
      node: A
    };
  }
  function B(c) {
    const g = c.context(), A = g.currentType === 1 ? c.currentOffset() : g.offset, f = g.currentType === 1 ? g.endLoc : g.startLoc, F = r(2, A, f);
    F.items = [];
    let S = null;
    do {
      const x = S || c.nextToken();
      switch (S = null, x.type) {
        case 0:
          x.value == null && n(c, 13, g.lastStartLoc, 0, i2(x)), F.items.push(u(c, x.value || ""));
          break;
        case 6:
          x.value == null && n(c, 13, g.lastStartLoc, 0, i2(x)), F.items.push(i(c, x.value || ""));
          break;
        case 5:
          x.value == null && n(c, 13, g.lastStartLoc, 0, i2(x)), F.items.push(C(c, x.value || ""));
          break;
        case 7:
          x.value == null && n(c, 13, g.lastStartLoc, 0, i2(x)), F.items.push(h(c, x.value || ""));
          break;
        case 8:
          const n2 = v(c);
          F.items.push(n2.node), S = n2.nextConsumeToken || null;
          break;
      }
    } while (g.currentType !== 14 && g.currentType !== 1);
    const E = g.currentType === 1 ? g.lastOffset : c.currentOffset(), K = g.currentType === 1 ? g.lastEndLoc : c.currentPosition();
    return s(F, E, K), F;
  }
  function L(c, g, A, f) {
    const F = c.context();
    let S = f.items.length === 0;
    const E = r(1, g, A);
    E.cases = [], E.cases.push(f);
    do {
      const K = B(c);
      S || (S = K.items.length === 0), E.cases.push(K);
    } while (F.currentType !== 14);
    return S && n(c, 10, A, 0), s(E, c.currentOffset(), c.currentPosition()), E;
  }
  function I(c) {
    const g = c.context(), { offset: A, startLoc: f } = g, F = B(c);
    return g.currentType === 14 ? F : L(c, A, f, F);
  }
  function y(c) {
    const g = $e(c, { ...e }), A = g.context(), f = r(0, A.offset, A.startLoc);
    return t && f.loc && (f.loc.source = c), f.body = I(g), A.currentType !== 14 && n(g, 13, A.lastStartLoc, 0, c[A.offset] || ""), s(f, g.currentOffset(), g.currentPosition()), f;
  }
  return { parse: y };
}
function i2(e) {
  if (e.type === 14)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function s1(e, t = {}) {
  const a = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => a, helper: (s) => (a.helpers.add(s), s) };
}
function U0(e, t) {
  for (let a = 0; a < e.length; a++)
    w0(e[a], t);
}
function w0(e, t) {
  switch (e.type) {
    case 1:
      U0(e.cases, t), t.helper(
        "plural"
        /* PLURAL */
      );
      break;
    case 2:
      U0(e.items, t);
      break;
    case 6:
      w0(e.key, t), t.helper(
        "linked"
        /* LINKED */
      );
      break;
    case 5:
      t.helper(
        "interpolate"
        /* INTERPOLATE */
      ), t.helper(
        "list"
        /* LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* INTERPOLATE */
      ), t.helper(
        "named"
        /* NAMED */
      );
      break;
  }
}
function o1(e, t = {}) {
  const a = s1(e);
  a.helper(
    "normalize"
    /* NORMALIZE */
  ), e.body && w0(e.body, a);
  const n = a.context();
  e.helpers = Array.from(n.helpers);
}
function r1(e, t) {
  const { filename: a, breakLineCode: n, needIndent: r } = t, s = {
    source: e.loc.source,
    filename: a,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: n,
    needIndent: r,
    indentLevel: 0
  }, u = () => s;
  function i(L, I) {
    s.code += L;
  }
  function C(L, I = !0) {
    const y = I ? n : "";
    i(r ? y + "  ".repeat(L) : y);
  }
  function h(L = !0) {
    const I = ++s.indentLevel;
    L && C(I);
  }
  function w(L = !0) {
    const I = --s.indentLevel;
    L && C(I);
  }
  function M() {
    C(s.indentLevel);
  }
  return {
    context: u,
    push: i,
    indent: h,
    deindent: w,
    newline: M,
    helper: (L) => `_${L}`,
    needIndent: () => s.needIndent
  };
}
function l1(e, t) {
  const { helper: a } = e;
  e.push(`${a(
    "linked"
    /* LINKED */
  )}(`), W2(e, t.key), t.modifier && (e.push(", "), W2(e, t.modifier)), e.push(")");
}
function c1(e, t) {
  const { helper: a, needIndent: n } = e;
  e.push(`${a(
    "normalize"
    /* NORMALIZE */
  )}([`), e.indent(n());
  const r = t.items.length;
  for (let s = 0; s < r && (W2(e, t.items[s]), s !== r - 1); s++)
    e.push(", ");
  e.deindent(n()), e.push("])");
}
function i1(e, t) {
  const { helper: a, needIndent: n } = e;
  if (t.cases.length > 1) {
    e.push(`${a(
      "plural"
      /* PLURAL */
    )}([`), e.indent(n());
    const r = t.cases.length;
    for (let s = 0; s < r && (W2(e, t.cases[s]), s !== r - 1); s++)
      e.push(", ");
    e.deindent(n()), e.push("])");
  }
}
function u1(e, t) {
  t.body ? W2(e, t.body) : e.push("null");
}
function W2(e, t) {
  const { helper: a } = e;
  switch (t.type) {
    case 0:
      u1(e, t);
      break;
    case 1:
      i1(e, t);
      break;
    case 2:
      c1(e, t);
      break;
    case 6:
      l1(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${a(
        "interpolate"
        /* INTERPOLATE */
      )}(${a(
        "list"
        /* LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${a(
        "interpolate"
        /* INTERPOLATE */
      )}(${a(
        "named"
        /* NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      if (process.env.NODE_ENV !== "production")
        throw new Error(`unhandled codegen node type: ${t.type}`);
  }
}
const d1 = (e, t = {}) => {
  const a = R(t.mode) ? t.mode : "normal", n = R(t.filename) ? t.filename : "message.intl";
  t.sourceMap;
  const r = t.breakLineCode != null ? t.breakLineCode : a === "arrow" ? ";" : `
`, s = t.needIndent ? t.needIndent : a !== "arrow", u = e.helpers || [], i = r1(e, {
    filename: n,
    breakLineCode: r,
    needIndent: s
  });
  i.push(a === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), i.indent(s), u.length > 0 && (i.push(`const { ${u.map((w) => `${w}: _${w}`).join(", ")} } = ctx`), i.newline()), i.push("return "), W2(i, e), i.deindent(s), i.push("}");
  const { code: C, map: h } = i.context();
  return {
    ast: e,
    code: C,
    map: h ? h.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function f1(e, t = {}) {
  const n = a1({ ...t }).parse(e);
  return o1(n, { ...t }), d1(n, { ...t });
}
/*!
  * @intlify/core-base v9.0.0
  * (c) 2021 kazuya kawaguchi
  * Released under the MIT License.
  */
const m1 = {
  0: "Not found '{key}' key in '{locale}' locale messages.",
  1: "Fall back to translate '{key}' key with '{target}' locale.",
  2: "Cannot format a number value due to not supported Intl.NumberFormat.",
  3: "Fall back to number format '{key}' key with '{target}' locale.",
  4: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  5: "Fall back to datetime format '{key}' key with '{target}' locale."
};
function B2(e, ...t) {
  return r0(m1[e], ...t);
}
const i0 = -1, a0 = "";
function C1() {
  return {
    upper: (e) => R(e) ? e.toUpperCase() : e,
    lower: (e) => R(e) ? e.toLowerCase() : e,
    // prettier-ignore
    capitalize: (e) => R(e) ? `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}` : e
  };
}
let oe;
function p1(e) {
  oe = e;
}
function g1(e = {}) {
  const t = R(e.locale) ? e.locale : "en-US", a = X(e.fallbackLocale) || U(e.fallbackLocale) || R(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : t, n = U(e.messages) ? e.messages : { [t]: {} }, r = U(e.datetimeFormats) ? e.datetimeFormats : { [t]: {} }, s = U(e.numberFormats) ? e.numberFormats : { [t]: {} }, u = Object.assign({}, e.modifiers || {}, C1()), i = e.pluralRules || {}, C = q(e.missing) ? e.missing : null, h = J(e.missingWarn) || t0(e.missingWarn) ? e.missingWarn : !0, w = J(e.fallbackWarn) || t0(e.fallbackWarn) ? e.fallbackWarn : !0, M = !!e.fallbackFormat, v = !!e.unresolving, B = q(e.postTranslation) ? e.postTranslation : null, L = U(e.processor) ? e.processor : null, I = J(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, y = !!e.escapeParameter, c = q(e.messageCompiler) ? e.messageCompiler : oe, g = q(e.onWarn) ? e.onWarn : K2, A = e, f = r2(A.__datetimeFormatters) ? A.__datetimeFormatters : /* @__PURE__ */ new Map(), F = r2(A.__numberFormatters) ? A.__numberFormatters : /* @__PURE__ */ new Map(), S = {
    locale: t,
    fallbackLocale: a,
    messages: n,
    datetimeFormats: r,
    numberFormats: s,
    modifiers: u,
    pluralRules: i,
    missing: C,
    missingWarn: h,
    fallbackWarn: w,
    fallbackFormat: M,
    unresolving: v,
    postTranslation: B,
    processor: L,
    warnHtmlMessage: I,
    escapeParameter: y,
    messageCompiler: c,
    onWarn: g,
    __datetimeFormatters: f,
    __numberFormatters: F
  };
  return process.env.NODE_ENV !== "production" && (S.__emitter = A.__emitter != null ? A.__emitter : void 0), S;
}
function y0(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function h1(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function M0(e, t, a, n, r) {
  const { missing: s, onWarn: u } = e;
  if (process.env.NODE_ENV !== "production") {
    const i = e.__emitter;
    i && i.emit("missing", {
      locale: a,
      key: t,
      type: r,
      groupId: `${r}:${t}`
    });
  }
  if (s !== null) {
    const i = s(e, a, t, r);
    return R(i) ? i : t;
  } else
    return process.env.NODE_ENV !== "production" && h1(n, t) && u(B2(0, { key: t, locale: a })), t;
}
function u0(e, t, a) {
  const n = e;
  n.__localeChainCache || (n.__localeChainCache = /* @__PURE__ */ new Map());
  let r = n.__localeChainCache.get(a);
  if (!r) {
    r = [];
    let s = [a];
    for (; X(s); )
      s = D0(r, s, t);
    const u = X(t) ? t : U(t) ? t.default ? t.default : null : t;
    s = R(u) ? [u] : u, X(s) && D0(r, s, !1), n.__localeChainCache.set(a, r);
  }
  return r;
}
function D0(e, t, a) {
  let n = !0;
  for (let r = 0; r < t.length && J(n); r++) {
    const s = t[r];
    R(s) && (n = A1(e, t[r], a));
  }
  return n;
}
function A1(e, t, a) {
  let n;
  const r = t.split("-");
  do {
    const s = r.join("-");
    n = v1(e, s, a), r.splice(-1, 1);
  } while (r.length && n === !0);
  return n;
}
function v1(e, t, a) {
  let n = !1;
  if (!e.includes(t) && (n = !0, t)) {
    n = t[t.length - 1] !== "!";
    const r = t.replace(/!/g, "");
    e.push(r), (X(a) || U(a)) && a[r] && (n = a[r]);
  }
  return n;
}
function Q2(e, t, a) {
  const n = e;
  n.__localeChainCache = /* @__PURE__ */ new Map(), u0(e, a, t);
}
const b1 = /<\/?[\w\s="/.':;#-\/]+>/, L1 = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function k1(e, t) {
  (J(t.warnHtmlMessage) ? t.warnHtmlMessage : !0) && b1.test(e) && K2(r0(L1, { source: e }));
}
const w1 = (e) => e;
let Z0 = /* @__PURE__ */ Object.create(null);
function y1(e, t = {}) {
  {
    process.env.NODE_ENV !== "production" && k1(e, t);
    const n = (t.onCacheKey || w1)(e), r = Z0[n];
    if (r)
      return r;
    let s = !1;
    const u = t.onError || Ge;
    t.onError = (h) => {
      s = !0, u(h);
    };
    const { code: i } = f1(e, t), C = new Function(`return ${i}`)();
    return s ? C : Z0[n] = C;
  }
}
function R2(e) {
  return c0(e, null, process.env.NODE_ENV !== "production" ? { messages: M1 } : void 0);
}
const M1 = {
  14: "Invalid arguments",
  15: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  16: "The argument provided is not a valid ISO date string"
}, x0 = () => "", s0 = (e) => q(e);
function Q0(e, ...t) {
  const { fallbackFormat: a, postTranslation: n, unresolving: r, fallbackLocale: s } = e, [u, i] = C0(...t), C = J(i.missingWarn) ? i.missingWarn : e.missingWarn, h = J(i.fallbackWarn) ? i.fallbackWarn : e.fallbackWarn, w = J(i.escapeParameter) ? i.escapeParameter : e.escapeParameter, M = R(i.default) || J(i.default) ? J(i.default) ? u : i.default : a ? u : "", v = a || M !== "", B = R(i.locale) ? i.locale : e.locale;
  w && S1(i);
  let [L, I, y] = F1(e, u, B, s, h, C), c = u;
  if (R(L) || s0(L) || v && (L = M, c = L), !(R(L) || s0(L)) || !R(I))
    return r ? i0 : u;
  if (process.env.NODE_ENV !== "production" && R(L) && e.messageCompiler == null)
    return K2(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${u}'.`), u;
  let g = !1;
  const f = re(e, u, I, L, c, () => {
    g = !0;
  });
  if (g)
    return L;
  const F = E1(e, I, y, i), S = Ke(F), E = I1(e, f, S);
  return n ? n(E) : E;
}
function S1(e) {
  X(e.list) ? e.list = e.list.map((t) => R(t) ? P0(t) : t) : r2(e.named) && Object.keys(e.named).forEach((t) => {
    R(e.named[t]) && (e.named[t] = P0(e.named[t]));
  });
}
function F1(e, t, a, n, r, s) {
  const { messages: u, onWarn: i } = e, C = u0(e, n, a);
  let h = {}, w, M = null, v = a, B = null;
  const L = "translate";
  for (let I = 0; I < C.length; I++) {
    if (w = B = C[I], process.env.NODE_ENV !== "production" && a !== w && y0(r, t) && i(B2(1, {
      key: t,
      target: w
    })), process.env.NODE_ENV !== "production" && a !== w) {
      const f = e.__emitter;
      f && f.emit("fallback", {
        type: L,
        key: t,
        from: v,
        to: B,
        groupId: `${L}:${t}`
      });
    }
    h = u[w] || {};
    let y = null, c, g;
    if (process.env.NODE_ENV !== "production" && M2 && (y = window.performance.now(), c = "intlify-message-resolve-start", g = "intlify-message-resolve-end", _ && _(c)), (M = n0(h, t)) === null && (M = h[t]), process.env.NODE_ENV !== "production" && M2) {
      const f = window.performance.now(), F = e.__emitter;
      F && y && M && F.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: M,
        time: f - y,
        groupId: `${L}:${t}`
      }), c && g && _ && S2 && (_(g), S2("intlify message resolve", c, g));
    }
    if (R(M) || q(M))
      break;
    const A = M0(e, t, w, s, L);
    A !== t && (M = A), v = B;
  }
  return [M, w, h];
}
function re(e, t, a, n, r, s) {
  const { messageCompiler: u, warnHtmlMessage: i } = e;
  if (s0(n)) {
    const v = n;
    return v.locale = v.locale || a, v.key = v.key || t, v;
  }
  let C = null, h, w;
  process.env.NODE_ENV !== "production" && M2 && (C = window.performance.now(), h = "intlify-message-compilation-start", w = "intlify-message-compilation-end", _ && _(h));
  const M = u(n, O1(e, a, r, n, i, s));
  if (process.env.NODE_ENV !== "production" && M2) {
    const v = window.performance.now(), B = e.__emitter;
    B && C && B.emit("message-compilation", {
      type: "message-compilation",
      message: n,
      time: v - C,
      groupId: `translate:${t}`
    }), h && w && _ && S2 && (_(w), S2("intlify message compilation", h, w));
  }
  return M.locale = a, M.key = t, M.source = n, M;
}
function I1(e, t, a) {
  let n = null, r, s;
  process.env.NODE_ENV !== "production" && M2 && (n = window.performance.now(), r = "intlify-message-evaluation-start", s = "intlify-message-evaluation-end", _ && _(r));
  const u = t(a);
  if (process.env.NODE_ENV !== "production" && M2) {
    const i = window.performance.now(), C = e.__emitter;
    C && n && C.emit("message-evaluation", {
      type: "message-evaluation",
      value: u,
      time: i - n,
      groupId: `translate:${t.key}`
    }), r && s && _ && S2 && (_(s), S2("intlify message evaluation", r, s));
  }
  return u;
}
function C0(...e) {
  const [t, a, n] = e, r = {};
  if (!R(t) && !z(t))
    throw R2(
      14
      /* INVALID_ARGUMENT */
    );
  const s = z(t) ? String(t) : t;
  return z(a) ? r.plural = a : R(a) ? r.default = a : U(a) && !l0(a) ? r.named = a : X(a) && (r.list = a), z(n) ? r.plural = n : R(n) ? r.default = n : U(n) && Object.assign(r, n), [s, r];
}
function O1(e, t, a, n, r, s) {
  return {
    warnHtmlMessage: r,
    onError: (u) => {
      if (s && s(u), process.env.NODE_ENV !== "production") {
        const i = `Message compilation error: ${u.message}`, C = u.location && Oe(n, u.location.start.offset, u.location.end.offset), h = e.__emitter;
        h && h.emit("compile-error", {
          message: n,
          error: u.message,
          start: u.location && u.location.start.offset,
          end: u.location && u.location.end.offset,
          groupId: `translate:${a}`
        }), console.error(C ? `${i}
${C}` : i);
      } else
        throw u;
    },
    onCacheKey: (u) => Me(t, a, u)
  };
}
function E1(e, t, a, n) {
  const { modifiers: r, pluralRules: s } = e, i = {
    locale: t,
    modifiers: r,
    pluralRules: s,
    messages: (C) => {
      const h = n0(a, C);
      if (R(h)) {
        let w = !1;
        const v = re(e, C, t, h, C, () => {
          w = !0;
        });
        return w ? x0 : v;
      } else return s0(h) ? h : x0;
    }
  };
  return e.processor && (i.processor = e.processor), n.list && (i.list = n.list), n.named && (i.named = n.named), z(n.plural) && (i.pluralIndex = n.plural), i;
}
const K0 = typeof Intl < "u", le = {
  dateTimeFormat: K0 && typeof Intl.DateTimeFormat < "u",
  numberFormat: K0 && typeof Intl.NumberFormat < "u"
};
function J0(e, ...t) {
  const { datetimeFormats: a, unresolving: n, fallbackLocale: r, onWarn: s } = e, { __datetimeFormatters: u } = e;
  if (process.env.NODE_ENV !== "production" && !le.dateTimeFormat)
    return s(B2(
      4
      /* CANNOT_FORMAT_DATE */
    )), a0;
  const [i, C, h, w] = p0(...t), M = J(h.missingWarn) ? h.missingWarn : e.missingWarn, v = J(h.fallbackWarn) ? h.fallbackWarn : e.fallbackWarn, B = !!h.part, L = R(h.locale) ? h.locale : e.locale, I = u0(e, r, L);
  if (!R(i) || i === "")
    return new Intl.DateTimeFormat(L).format(C);
  let y = {}, c, g = null, A = L, f = null;
  const F = "datetime format";
  for (let K = 0; K < I.length; K++) {
    if (c = f = I[K], process.env.NODE_ENV !== "production" && L !== c && y0(v, i) && s(B2(5, {
      key: i,
      target: c
    })), process.env.NODE_ENV !== "production" && L !== c) {
      const x = e.__emitter;
      x && x.emit("fallback", {
        type: F,
        key: i,
        from: A,
        to: f,
        groupId: `${F}:${i}`
      });
    }
    if (y = a[c] || {}, g = y[i], U(g))
      break;
    M0(e, i, c, M, F), A = f;
  }
  if (!U(g) || !R(c))
    return n ? i0 : i;
  let S = `${c}__${i}`;
  l0(w) || (S = `${S}__${JSON.stringify(w)}`);
  let E = u.get(S);
  return E || (E = new Intl.DateTimeFormat(c, Object.assign({}, g, w)), u.set(S, E)), B ? E.formatToParts(C) : E.format(C);
}
function p0(...e) {
  const [t, a, n, r] = e;
  let s = {}, u = {}, i;
  if (R(t)) {
    if (!/\d{4}-\d{2}-\d{2}(T.*)?/.test(t))
      throw R2(
        16
        /* INVALID_ISO_DATE_ARGUMENT */
      );
    i = new Date(t);
    try {
      i.toISOString();
    } catch {
      throw R2(
        16
        /* INVALID_ISO_DATE_ARGUMENT */
      );
    }
  } else if (Fe(t)) {
    if (isNaN(t.getTime()))
      throw R2(
        15
        /* INVALID_DATE_ARGUMENT */
      );
    i = t;
  } else if (z(t))
    i = t;
  else
    throw R2(
      14
      /* INVALID_ARGUMENT */
    );
  return R(a) ? s.key = a : U(a) && (s = a), R(n) ? s.locale = n : U(n) && (u = n), U(r) && (u = r), [s.key || "", i, s, u];
}
function G0(e, t, a) {
  const n = e;
  for (const r in a) {
    const s = `${t}__${r}`;
    n.__datetimeFormatters.has(s) && n.__datetimeFormatters.delete(s);
  }
}
function Y0(e, ...t) {
  const { numberFormats: a, unresolving: n, fallbackLocale: r, onWarn: s } = e, { __numberFormatters: u } = e;
  if (process.env.NODE_ENV !== "production" && !le.numberFormat)
    return s(B2(
      2
      /* CANNOT_FORMAT_NUMBER */
    )), a0;
  const [i, C, h, w] = g0(...t), M = J(h.missingWarn) ? h.missingWarn : e.missingWarn, v = J(h.fallbackWarn) ? h.fallbackWarn : e.fallbackWarn, B = !!h.part, L = R(h.locale) ? h.locale : e.locale, I = u0(e, r, L);
  if (!R(i) || i === "")
    return new Intl.NumberFormat(L).format(C);
  let y = {}, c, g = null, A = L, f = null;
  const F = "number format";
  for (let K = 0; K < I.length; K++) {
    if (c = f = I[K], process.env.NODE_ENV !== "production" && L !== c && y0(v, i) && s(B2(3, {
      key: i,
      target: c
    })), process.env.NODE_ENV !== "production" && L !== c) {
      const x = e.__emitter;
      x && x.emit("fallback", {
        type: F,
        key: i,
        from: A,
        to: f,
        groupId: `${F}:${i}`
      });
    }
    if (y = a[c] || {}, g = y[i], U(g))
      break;
    M0(e, i, c, M, F), A = f;
  }
  if (!U(g) || !R(c))
    return n ? i0 : i;
  let S = `${c}__${i}`;
  l0(w) || (S = `${S}__${JSON.stringify(w)}`);
  let E = u.get(S);
  return E || (E = new Intl.NumberFormat(c, Object.assign({}, g, w)), u.set(S, E)), B ? E.formatToParts(C) : E.format(C);
}
function g0(...e) {
  const [t, a, n, r] = e;
  let s = {}, u = {};
  if (!z(t))
    throw R2(
      14
      /* INVALID_ARGUMENT */
    );
  const i = t;
  return R(a) ? s.key = a : U(a) && (s = a), R(n) ? s.locale = n : U(n) && (u = n), U(r) && (u = r), [s.key || "", i, s, u];
}
function j0(e, t, a) {
  const n = e;
  for (const r in a) {
    const s = `${t}__${r}`;
    n.__numberFormatters.has(s) && n.__numberFormatters.delete(s);
  }
}
function H1() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(a, n) {
      const r = e.get(a);
      r && r.push(n) || e.set(a, [n]);
    },
    off(a, n) {
      const r = e.get(a);
      r && r.splice(r.indexOf(n) >>> 0, 1);
    },
    emit(a, n) {
      (e.get(a) || []).slice().map((r) => r(n)), (e.get("*") || []).slice().map((r) => r(a, n));
    }
  };
}
/*!
  * vue-i18n v9.0.0
  * (c) 2021 kazuya kawaguchi
  * Released under the MIT License.
  */
function T1() {
  let e = !1;
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (e = !0, _2().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (e = !0, _2().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (e = !0, _2().__INTLIFY_PROD_DEVTOOLS__ = !1), process.env.NODE_ENV !== "production" && e && console.warn("You are running the esm-bundler build of vue-i18n. It is recommended to configure your bundler to explicitly replace feature flag globals with boolean literals to get proper tree-shaking in the final bundle.");
}
function N1() {
  const e = _2();
  e.__INTLIFY__ = !0, console.info(`You are running a development build of vue-i18n.
Make sure to use the production build (*.prod.js) when deploying for production.`);
}
const P1 = {
  6: "Fall back to {type} '{key}' with root locale.",
  7: "Not supported 'preserve'.",
  8: "Not supported 'formatter'.",
  9: "Not supported 'preserveDirectiveContent'.",
  10: "Not supported 'getChoiceIndex'.",
  11: "Component name legacy compatible: '{name}' -> 'i18n'",
  12: "Not found parent scope. use the global scope."
};
function ce(e, ...t) {
  return r0(P1[e], ...t);
}
function V2(e, ...t) {
  return c0(e, null, process.env.NODE_ENV !== "production" ? { messages: R1, args: t } : void 0);
}
const R1 = {
  14: "Unexpected return type in composer",
  15: "Invalid argument",
  16: "Must be called at the top of a `setup` function",
  17: "Need to install with `app.use` function",
  22: "Unexpected error",
  18: "Not available in legacy mode",
  19: "Required in value: {0}",
  20: "Invalid value",
  21: "Cannot setup vue-devtools plugin"
}, q0 = U2("__transrateVNode"), X0 = U2("__datetimeParts"), z0 = U2("__numberParts"), h0 = U2("__enableEmitter"), A0 = U2("__disableEmitter"), V1 = U2("__setPluralRules");
let _0 = 0;
function $0(e) {
  return (t, a, n, r) => e(a, n, te() || void 0, r);
}
function ie(e, t) {
  const { messages: a, __i18n: n } = t, r = U(a) ? a : X(n) ? {} : { [e]: {} };
  return X(n) && n.forEach(({ locale: s, resource: u }) => {
    s ? (r[s] = r[s] || {}, o0(u, r[s])) : o0(u, r);
  }), r;
}
const W1 = Object.prototype.hasOwnProperty;
function B1(e, t) {
  return W1.call(e, t);
}
const z2 = (e) => !r2(e) || X(e);
function o0(e, t) {
  if (z2(e) || z2(t))
    throw V2(
      20
      /* INVALID_VALUE */
    );
  for (const a in e)
    B1(e, a) && (z2(e[a]) || z2(t[a]) ? t[a] = e[a] : o0(e[a], t[a]));
}
function U1(e = {}) {
  const { __root: t } = e, a = t === void 0;
  let n = J(e.inheritLocale) ? e.inheritLocale : !0;
  const r = j(
    // prettier-ignore
    t && n ? t.locale.value : R(e.locale) ? e.locale : "en-US"
  ), s = j(
    // prettier-ignore
    t && n ? t.fallbackLocale.value : R(e.fallbackLocale) || X(e.fallbackLocale) || U(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : r.value
  ), u = j(ie(r.value, e)), i = j(U(e.datetimeFormats) ? e.datetimeFormats : { [r.value]: {} }), C = j(U(e.numberFormats) ? e.numberFormats : { [r.value]: {} });
  let h = t ? t.missingWarn : J(e.missingWarn) || t0(e.missingWarn) ? e.missingWarn : !0, w = t ? t.fallbackWarn : J(e.fallbackWarn) || t0(e.fallbackWarn) ? e.fallbackWarn : !0, M = t ? t.fallbackRoot : J(e.fallbackRoot) ? e.fallbackRoot : !0, v = !!e.fallbackFormat, B = q(e.missing) ? e.missing : null, L = q(e.missing) ? $0(e.missing) : null, I = q(e.postTranslation) ? e.postTranslation : null, y = J(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, c = !!e.escapeParameter;
  const g = t ? t.modifiers : U(e.modifiers) ? e.modifiers : {};
  let A = e.pluralRules || t && t.pluralRules, f;
  function F() {
    return g1({
      locale: r.value,
      fallbackLocale: s.value,
      messages: u.value,
      datetimeFormats: i.value,
      numberFormats: C.value,
      modifiers: g,
      pluralRules: A,
      missing: L === null ? void 0 : L,
      missingWarn: h,
      fallbackWarn: w,
      fallbackFormat: v,
      unresolving: !0,
      postTranslation: I === null ? void 0 : I,
      warnHtmlMessage: y,
      escapeParameter: c,
      __datetimeFormatters: U(f) ? f.__datetimeFormatters : void 0,
      __numberFormatters: U(f) ? f.__numberFormatters : void 0,
      __emitter: U(f) ? f.__emitter : void 0
    });
  }
  f = F(), Q2(f, r.value, s.value);
  const S = w2({
    get: () => r.value,
    set: (m) => {
      r.value = m, f.locale = r.value;
    }
  }), E = w2({
    get: () => s.value,
    set: (m) => {
      s.value = m, f.fallbackLocale = s.value, Q2(f, r.value, m);
    }
  }), K = w2(() => u.value), x = w2(() => i.value), n2 = w2(() => C.value);
  function A2() {
    return q(I) ? I : null;
  }
  function u2(m) {
    I = m, f.postTranslation = m;
  }
  function F2() {
    return B;
  }
  function I2(m) {
    m !== null && (L = $0(m)), B = m, f.missing = L;
  }
  function $(m, k, s2, k2, de, fe) {
    const S0 = F(), J2 = m(S0);
    if (z(J2) && J2 === i0) {
      const G2 = k();
      if (process.env.NODE_ENV !== "production" && t && (M || K2(ce(6, {
        key: G2,
        type: s2
      })), process.env.NODE_ENV !== "production")) {
        const { __emitter: F0 } = S0;
        F0 && F0.emit("fallback", {
          type: s2,
          key: G2,
          to: "global",
          groupId: `${s2}:${G2}`
        });
      }
      return t && M ? k2(t) : de(G2);
    } else {
      if (fe(J2))
        return J2;
      throw V2(
        14
        /* UNEXPECTED_RETURN_TYPE */
      );
    }
  }
  function v2(...m) {
    return $((k) => Q0(k, ...m), () => C0(...m)[0], "translate", (k) => k.t(...m), (k) => k, (k) => R(k));
  }
  function b2(...m) {
    return $((k) => J0(k, ...m), () => p0(...m)[0], "datetime format", (k) => k.d(...m), () => a0, (k) => R(k));
  }
  function a2(...m) {
    return $((k) => Y0(k, ...m), () => g0(...m)[0], "number format", (k) => k.n(...m), () => a0, (k) => R(k));
  }
  function D2(m) {
    return m.map((k) => R(k) ? o2(I0, null, k, 0) : k);
  }
  const x2 = {
    normalize: D2,
    interpolate: (m) => m,
    type: "vnode"
  };
  function L2(...m) {
    return $(
      (k) => {
        let s2;
        const k2 = k;
        try {
          k2.processor = x2, s2 = Q0(k2, ...m);
        } finally {
          k2.processor = null;
        }
        return s2;
      },
      () => C0(...m)[0],
      "translate",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (k) => k[q0](...m),
      (k) => [o2(I0, null, k, 0)],
      (k) => X(k)
    );
  }
  function d2(...m) {
    return $(
      (k) => Y0(k, ...m),
      () => g0(...m)[0],
      "number format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (k) => k[z0](...m),
      () => [],
      (k) => R(k) || X(k)
    );
  }
  function l2(...m) {
    return $(
      (k) => J0(k, ...m),
      () => p0(...m)[0],
      "datetime format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (k) => k[X0](...m),
      () => [],
      (k) => R(k) || X(k)
    );
  }
  function O2(m) {
    A = m, f.pluralRules = A;
  }
  function N(m, k) {
    const s2 = R(k) ? k : r.value, k2 = Z(s2);
    return n0(k2, m) !== null;
  }
  function P(m) {
    const k = u.value[r.value] || {}, s2 = n0(k, m);
    return s2 ?? (t ? t.tm(m) || {} : {});
  }
  function Z(m) {
    return u.value[m] || {};
  }
  function G(m, k) {
    u.value[m] = k, f.messages = u.value;
  }
  function C2(m, k) {
    u.value[m] = u.value[m] || {}, o0(k, u.value[m]), f.messages = u.value;
  }
  function o(m) {
    return i.value[m] || {};
  }
  function l(m, k) {
    i.value[m] = k, f.datetimeFormats = i.value, G0(f, m, k);
  }
  function d(m, k) {
    i.value[m] = Object.assign(i.value[m] || {}, k), f.datetimeFormats = i.value, G0(f, m, k);
  }
  function p(m) {
    return C.value[m] || {};
  }
  function H(m, k) {
    C.value[m] = k, f.numberFormats = C.value, j0(f, m, k);
  }
  function D(m, k) {
    C.value[m] = Object.assign(C.value[m] || {}, k), f.numberFormats = C.value, j0(f, m, k);
  }
  _0++, t && ($2(t.locale, (m) => {
    n && (r.value = m, f.locale = m, Q2(f, r.value, s.value));
  }), $2(t.fallbackLocale, (m) => {
    n && (s.value = m, f.fallbackLocale = m, Q2(f, r.value, s.value));
  }));
  const e2 = {
    id: _0,
    locale: S,
    fallbackLocale: E,
    get inheritLocale() {
      return n;
    },
    set inheritLocale(m) {
      n = m, m && t && (r.value = t.locale.value, s.value = t.fallbackLocale.value, Q2(f, r.value, s.value));
    },
    get availableLocales() {
      return Object.keys(u.value).sort();
    },
    messages: K,
    datetimeFormats: x,
    numberFormats: n2,
    get modifiers() {
      return g;
    },
    get pluralRules() {
      return A || {};
    },
    get isGlobal() {
      return a;
    },
    get missingWarn() {
      return h;
    },
    set missingWarn(m) {
      h = m, f.missingWarn = h;
    },
    get fallbackWarn() {
      return w;
    },
    set fallbackWarn(m) {
      w = m, f.fallbackWarn = w;
    },
    get fallbackRoot() {
      return M;
    },
    set fallbackRoot(m) {
      M = m;
    },
    get fallbackFormat() {
      return v;
    },
    set fallbackFormat(m) {
      v = m, f.fallbackFormat = v;
    },
    get warnHtmlMessage() {
      return y;
    },
    set warnHtmlMessage(m) {
      y = m, f.warnHtmlMessage = m;
    },
    get escapeParameter() {
      return c;
    },
    set escapeParameter(m) {
      c = m, f.escapeParameter = m;
    },
    t: v2,
    d: b2,
    n: a2,
    te: N,
    tm: P,
    getLocaleMessage: Z,
    setLocaleMessage: G,
    mergeLocaleMessage: C2,
    getDateTimeFormat: o,
    setDateTimeFormat: l,
    mergeDateTimeFormat: d,
    getNumberFormat: p,
    setNumberFormat: H,
    mergeNumberFormat: D,
    getPostTranslationHandler: A2,
    setPostTranslationHandler: u2,
    getMissingHandler: F2,
    setMissingHandler: I2,
    [q0]: L2,
    [z0]: d2,
    [X0]: l2,
    [V1]: O2
  };
  return process.env.NODE_ENV !== "production" && (e2[h0] = (m) => {
    f.__emitter = m;
  }, e2[A0] = () => {
    f.__emitter = void 0;
  }), e2;
}
function ee(e, t) {
}
function D1(e = {}) {
  const t = te();
  if (t == null)
    throw V2(
      16
      /* MUST_BE_CALL_SETUP_TOP */
    );
  if (!t.appContext.app.__VUE_I18N_SYMBOL__)
    throw V2(
      17
      /* NOT_INSLALLED */
    );
  const a = me(t.appContext.app.__VUE_I18N_SYMBOL__);
  if (!a)
    throw V2(
      22
      /* UNEXPECTED_ERROR */
    );
  const n = a.mode === "composition" ? a.global : a.global.__composer, r = l0(e) ? "__i18n" in t.type ? "local" : "global" : e.useScope ? e.useScope : "local";
  if (r === "global") {
    let i = r2(e.messages) ? e.messages : {};
    "__i18nGlobal" in t.type && (i = ie(n.locale.value, {
      messages: i,
      __i18n: t.type.__i18nGlobal
    }));
    const C = Object.keys(i);
    if (C.length && C.forEach((h) => {
      n.mergeLocaleMessage(h, i[h]);
    }), r2(e.datetimeFormats)) {
      const h = Object.keys(e.datetimeFormats);
      h.length && h.forEach((w) => {
        n.mergeDateTimeFormat(w, e.datetimeFormats[w]);
      });
    }
    if (r2(e.numberFormats)) {
      const h = Object.keys(e.numberFormats);
      h.length && h.forEach((w) => {
        n.mergeNumberFormat(w, e.numberFormats[w]);
      });
    }
    return n;
  }
  if (r === "parent") {
    let i = Z1(a, t);
    return i == null && (process.env.NODE_ENV !== "production" && K2(ce(
      12
      /* NOT_FOUND_PARENT_SCOPE */
    )), i = n), i;
  }
  if (a.mode === "legacy")
    throw V2(
      18
      /* NOT_AVAILABLE_IN_LEGACY_MODE */
    );
  const s = a;
  let u = s.__getInstance(t);
  if (u == null) {
    const i = t.type, C = {
      ...e
    };
    i.__i18n && (C.__i18n = i.__i18n), n && (C.__root = n), u = U1(C), x1(s, t, u), s.__setInstance(t, u);
  }
  return u;
}
function Z1(e, t) {
  let a = null;
  const n = t.root;
  let r = t.parent;
  for (; r != null; ) {
    const s = e;
    if (e.mode === "composition")
      a = s.__getInstance(r);
    else {
      const u = s.__getInstance(r);
      u != null && (a = u.__composer);
    }
    if (a != null || n === r)
      break;
    r = r.parent;
  }
  return a;
}
function x1(e, t, a) {
  let n = null;
  b0(() => {
    if ((process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && t.vnode.el) {
      t.vnode.el.__INTLIFY__ = a, n = H1();
      const r = a;
      r[h0] && r[h0](n), n.on("*", ee);
    }
  }, t), Ce(() => {
    if ((process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && t.vnode.el && t.vnode.el.__INTLIFY__) {
      n && n.off("*", ee);
      const r = a;
      r[A0] && r[A0](), delete t.vnode.el.__INTLIFY__;
    }
    e.__deleteInstance(t);
  }, t);
}
p1(y1);
T1();
process.env.NODE_ENV !== "production" && N1();
const Q1 = { apoc: "apoc", play: "play", studio: "studio", asset: "asset", comm: "community", studioList: { home: "studio home", pricing: "pricing" }, assetList: { home: "asset home", icon3d: "icon 3D", reality3d: "reality 3D", made3d: "made 3D", background: "background", pricing: "pricing" }, commList: { home: "community home", apocNews: "apoc 뉴스", howToUse: "매뉴얼", board: "자유게시판", notice: "공지사항" } }, K1 = { ko: "한국어 ", en: "English " }, J1 = { make: "만들기" }, G1 = {
  megaMenu: Q1,
  lang: K1,
  studio: J1
}, Y1 = { apoc: "apoc", play: "play", studio: "studio", asset: "asset", comm: "community", studioList: { home: "studio home", pricing: "pricing" }, assetList: { home: "asset home", icon3d: "icon 3D", reality3d: "reality 3D", made3d: "made 3D", background: "background", pricing: "pricing" }, commList: { communityHome: "community home", apocNews: "apoc news", howToUse: "how to use", board: "board", notice: "notice" } }, j1 = { ko: "한국어 ", en: "English " }, q1 = { make: "Create" }, X1 = {
  megaMenu: Y1,
  lang: j1,
  studio: q1
}, z1 = "data:image/svg+xml,%3csvg%20width='112'%20height='32'%20viewBox='0%200%20112%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_1184_14136)'%3e%3cpath%20d='M84.906%2020.1595C84.7619%2020.3332%2084.6043%2020.5043%2084.4412%2020.6674C83.1066%2021.9798%2081.5465%2022.6159%2079.671%2022.6159C77.7956%2022.6159%2076.2381%2021.9824%2074.9144%2020.6807C73.5907%2019.379%2072.9466%2017.8474%2072.9466%2016.0031C72.9466%2014.1562%2073.5907%2012.6273%2074.9144%2011.3256C76.2381%2010.0239%2077.7956%209.39038%2079.671%209.39038C81.5465%209.39038%2083.1094%2010.0292%2084.4412%2011.3389C84.6043%2011.4993%2084.7619%2011.6704%2084.906%2011.8468L85.4442%2012.4936L88.3552%2010.1254L87.8034%209.48393C87.586%209.23268%2087.3495%208.97875%2087.094%208.73017C85.0473%206.71747%2082.5494%205.6991%2079.6683%205.6991C76.7872%205.6991%2074.292%206.7148%2072.2562%208.7168C70.2204%2010.7188%2069.1875%2013.1725%2069.1875%2016.0058C69.1875%2018.8391%2070.2204%2021.2928%2072.2562%2023.2948C74.292%2025.2968%2076.7872%2026.3125%2079.6683%2026.3125C82.5494%2026.3125%2085.0473%2025.2915%2087.094%2023.2815C87.3468%2023.0329%2087.586%2022.7789%2087.8034%2022.5277L88.3552%2021.8862L85.4442%2019.518L84.906%2020.1649V20.1595Z'%20fill='white'/%3e%3cpath%20d='M16.5203%207.56962C14.7509%206.32137%2012.7259%205.69324%2010.4835%205.69324C7.60239%205.69324%205.10722%206.70894%203.0714%208.71095C1.03286%2010.713%200%2013.1667%200%2016C0%2018.8332%201.03286%2021.287%203.06868%2023.289C5.1045%2025.291%207.59967%2026.3067%2010.4808%2026.3067C12.7259%2026.3067%2014.7509%2025.6759%2016.5176%2024.4303V25.6304H20.2739V6.34275H16.5176V7.56962H16.5203ZM16.5203%2018.9749C16.2023%2019.5816%2015.7783%2020.151%2015.2537%2020.6668C13.9191%2021.9792%2012.359%2022.6154%2010.4835%2022.6154C8.60807%2022.6154%207.05062%2021.9819%205.72693%2020.6802C4.40324%2019.3785%203.75906%2017.8469%203.75906%2016.0026C3.75906%2014.1583%204.40324%2012.6267%205.72693%2011.325C7.05062%2010.0233%208.60807%209.38986%2010.4835%209.38986C12.359%209.38986%2013.9246%2010.0207%2015.2455%2011.3037C15.7728%2011.8382%2016.2023%2012.4183%2016.5203%2013.0304V18.9776V18.9749Z'%20fill='white'/%3e%3cpath%20d='M33.8584%205.69324C31.6132%205.69324%2029.5883%206.32404%2027.8188%207.56962V6.36948H24.0625V32H27.8188V24.4303C29.5883%2025.6785%2031.6132%2026.3067%2033.8584%2026.3067C36.7395%2026.3067%2039.2347%2025.291%2041.2705%2023.289C43.3063%2021.287%2044.3392%2018.8332%2044.3392%2016C44.3392%2013.1667%2043.3063%2010.7156%2041.2705%208.71095C39.2319%206.70894%2036.7395%205.69324%2033.8584%205.69324ZM33.8584%2022.6154C31.9802%2022.6154%2030.4309%2021.9873%2029.1154%2020.6936C28.5745%2020.1617%2028.1396%2019.5843%2027.8216%2018.9749V13.0277C28.1369%2012.4236%2028.5717%2011.857%2029.1208%2011.3331C30.4363%2010.0233%2031.9856%209.38719%2033.8611%209.38719C35.7365%209.38719%2037.294%2010.0207%2038.6177%2011.3224C39.9441%2012.6267%2040.5855%2014.1557%2040.5855%2016C40.5855%2017.8443%2039.9414%2019.3758%2038.6177%2020.6775C37.294%2021.9792%2035.7365%2022.6127%2033.8611%2022.6127L33.8584%2022.6154Z'%20fill='white'/%3e%3cpath%20d='M64.016%208.71095C61.9774%206.70894%2059.485%205.69324%2056.6039%205.69324C53.7227%205.69324%2051.2275%206.70894%2049.1917%208.71095C47.1559%2010.713%2046.123%2013.1667%2046.123%2016C46.123%2018.8332%2047.1559%2021.287%2049.1917%2023.289C51.2275%2025.291%2053.7227%2026.3067%2056.6039%2026.3067C59.485%2026.3067%2061.9802%2025.291%2064.016%2023.289C66.0518%2021.287%2067.0847%2018.8332%2067.0847%2016C67.0847%2013.1667%2066.0518%2010.7156%2064.016%208.71095ZM56.6039%2022.6154C54.7257%2022.6154%2053.171%2021.9819%2051.8473%2020.6802C50.5236%2019.3785%2049.8794%2017.8469%2049.8794%2016.0026C49.8794%2014.1583%2050.5236%2012.6267%2051.8473%2011.325C53.171%2010.0233%2054.7284%209.38986%2056.6039%209.38986C58.4793%209.38986%2060.0367%2010.0233%2061.3604%2011.325C62.6868%2012.6294%2063.3283%2014.1583%2063.3283%2016.0026C63.3283%2017.8469%2062.6841%2019.3785%2061.3604%2020.6802C60.0367%2021.9819%2058.4793%2022.6154%2056.6039%2022.6154Z'%20fill='white'/%3e%3cpath%20d='M105.259%200L88.9883%2016L105.259%2032C114.244%2023.1634%20114.244%208.83662%20105.259%200Z'%20fill='url(%23paint0_linear_1184_14136)'/%3e%3c/g%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_1184_14136'%20x1='88.9883'%20y1='16'%20x2='111.999'%20y2='16'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.11'%20stop-color='%23FF99FF'/%3e%3cstop%20offset='0.24'%20stop-color='%23E48BFF'/%3e%3cstop%20offset='0.6'%20stop-color='%239F68FF'/%3e%3cstop%20offset='0.87'%20stop-color='%237453FF'/%3e%3cstop%20offset='1'%20stop-color='%23644BFF'/%3e%3c/linearGradient%3e%3cclipPath%20id='clip0_1184_14136'%3e%3crect%20width='112'%20height='32'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", _1 = "data:image/webp;base64,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", $1 = "data:image/webp;base64,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", et = "data:image/svg+xml,%3csvg%20width='66'%20height='28'%20viewBox='0%200%2066%2028'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M9.71905%204.42052C8.67838%203.67967%207.48905%203.30463%206.16655%203.30463C4.47237%203.30463%203.00429%203.90715%201.80567%205.09683C0.607053%206.2865%200%207.74055%200%209.42515C0%2011.1098%200.607053%2012.5638%201.80567%2013.7504C3.00429%2014.9401%204.46927%2015.5426%206.16655%2015.5426C7.48596%2015.5426%208.67838%2015.1676%209.71905%2014.4298V15.143H11.9274V3.69196H9.71905V4.42052ZM9.71905%2011.1897C9.53321%2011.5494%209.28234%2011.8875%208.97262%2012.1949C8.18902%2012.9727%207.26915%2013.3508%206.16655%2013.3508C5.06394%2013.3508%204.14716%2012.9757%203.36976%2012.2011C2.58927%2011.4264%202.21141%2010.5195%202.21141%209.42515C2.21141%208.33078%202.58927%207.42084%203.36976%206.64924C4.15026%205.87457%205.06394%205.49953%206.16655%205.49953C7.26915%205.49953%208.18902%205.87457%208.96642%206.63695C9.27614%206.95358%209.53012%207.29788%209.71595%207.66062V11.1897H9.71905Z'%20fill='black'/%3e%3cpath%20d='M19.9132%203.30463C18.5937%203.30463%2017.4013%203.67967%2016.3607%204.42052V3.70733H14.1523V19.0624H16.3607V14.4298C17.4013%2015.1706%2018.5906%2015.5457%2019.9132%2015.5457C21.6073%2015.5457%2023.0754%2014.9432%2024.2709%2013.7535C25.4665%2012.5638%2026.0766%2011.1098%2026.0766%209.42823C26.0766%207.7467%2025.4696%206.28957%2024.2709%205.0999C23.0723%203.91022%2021.6073%203.3077%2019.9132%203.3077V3.30463ZM19.9132%2013.3508C18.8105%2013.3508%2017.8969%2012.9788%2017.1226%2012.2103C16.8036%2011.8937%2016.5496%2011.5524%2016.3607%2011.1897V7.66062C16.5465%207.30095%2016.8005%206.96587%2017.1226%206.65539C17.8969%205.87764%2018.8075%205.49953%2019.9101%205.49953C21.0127%205.49953%2021.9294%205.87457%2022.7068%206.64924C23.4873%207.42392%2023.8652%208.33078%2023.8652%209.42515C23.8652%2010.5195%2023.4873%2011.4295%2022.7068%2012.2011C21.9263%2012.9757%2021.0127%2013.3508%2019.9101%2013.3508H19.9132Z'%20fill='black'/%3e%3cpath%20d='M37.6532%205.09682C36.4546%203.90715%2034.9896%203.30463%2033.2954%203.30463C31.6013%203.30463%2030.1332%203.90715%2028.9346%205.09682C27.736%206.2865%2027.1289%207.74055%2027.1289%209.42515C27.1289%2011.1098%2027.736%2012.5638%2028.9346%2013.7504C30.1332%2014.9401%2031.5982%2015.5426%2033.2954%2015.5426C34.9927%2015.5426%2036.4577%2014.9401%2037.6532%2013.7504C38.8518%2012.5607%2039.4589%2011.1067%2039.4589%209.42515C39.4589%207.74362%2038.8518%206.2865%2037.6532%205.09682ZM33.2954%2013.3508C32.1928%2013.3508%2031.2761%2012.9757%2030.4987%2012.2011C29.7182%2011.4264%2029.3403%2010.5195%2029.3403%209.42515C29.3403%208.33077%2029.7182%207.42084%2030.4987%206.64924C31.2792%205.87457%2032.1928%205.49953%2033.2954%205.49953C34.3981%205.49953%2035.3148%205.87457%2036.0922%206.64924C36.8727%207.42392%2037.2506%208.33077%2037.2506%209.42515C37.2506%2010.5195%2036.8727%2011.4295%2036.0922%2012.2011C35.3117%2012.9757%2034.3981%2013.3508%2033.2954%2013.3508Z'%20fill='black'/%3e%3cpath%20d='M49.9397%2011.8934C49.853%2011.9979%2049.7631%2012.0993%2049.664%2012.1946C48.8804%2012.9724%2047.9606%2013.3505%2046.858%2013.3505C45.7553%2013.3505%2044.8386%2012.9754%2044.0612%2012.2008C43.2807%2011.4261%2042.9028%2010.5192%2042.9028%209.42486C42.9028%208.33048%2043.2807%207.42055%2044.0612%206.64895C44.8417%205.87428%2045.7553%205.49924%2046.858%205.49924C47.9606%205.49924%2048.8742%205.87121%2049.6578%206.63358C49.7569%206.74118%2049.8499%206.84877%2049.9397%206.95944L50.2556%207.3437L51.9683%205.93884L51.6431%205.55765C51.5193%205.41317%2051.3861%205.26254%2051.225%205.09346C50.0233%203.90994%2048.5521%203.31049%2046.858%203.31049C45.1638%203.31049%2043.6957%203.91301%2042.4971%205.10268C41.2985%206.29236%2040.6914%207.7464%2040.6914%209.43101C40.6914%2011.1156%2041.2985%2012.5697%2042.4971%2013.7563C43.6957%2014.9459%2045.1607%2015.5485%2046.858%2015.5485C48.5552%2015.5485%2050.0233%2014.9429%2051.225%2013.747C51.3737%2013.5995%2051.5131%2013.4489%2051.64%2013.2982L51.9653%2012.917L50.2525%2011.5122L49.9366%2011.8964L49.9397%2011.8934Z'%20fill='black'/%3e%3cpath%20d='M62.0391%200L52.4688%209.49896L62.0391%2018.9979C67.323%2013.7535%2067.323%205.24748%2062.0391%200.0030741V0Z'%20fill='url(%23paint0_linear_1172_7252)'/%3e%3cpath%20d='M37.8354%2021.7661C37.8354%2023.4353%2036.6491%2024.5113%2035.2182%2024.5113C34.4718%2024.5113%2033.7408%2024.1977%2033.3909%2023.6044V26.491H32.2852V19.147H33.3909V19.9309C33.7408%2019.3376%2034.509%2019.0117%2035.2182%2019.0117C36.6398%2019.0117%2037.8354%2020.1092%2037.8354%2021.7661ZM36.7173%2021.7784C36.7173%2020.7916%2035.9956%2020.0415%2035.0819%2020.0415C34.1683%2020.0415%2033.4002%2020.724%2033.4002%2021.7784C33.4002%2022.8328%2034.2705%2023.4815%2035.0819%2023.4815C35.9956%2023.4815%2036.7173%2022.7652%2036.7173%2021.7784Z'%20fill='black'/%3e%3cpath%20d='M38.762%2024.3768V16.959H39.8677V24.3768H38.762Z'%20fill='black'/%3e%3cpath%20d='M45.236%2019.145H46.3417V24.3741H45.236V23.4887C44.8984%2024.0943%2044.1767%2024.5093%2043.3622%2024.5093C41.9839%2024.5093%2040.8008%2023.3658%2040.8008%2021.7549C40.8008%2020.1441%2041.9189%2019.0098%2043.4086%2019.0098C44.1767%2019.0098%2044.8984%2019.3356%2045.236%2019.9289V19.145ZM45.2236%2021.7549C45.2236%2020.7466%2044.3781%2020.0427%2043.5294%2020.0427C42.6281%2020.0427%2041.9158%2020.8266%2041.9158%2021.7549C41.9158%2022.6833%2042.6281%2023.4795%2043.5511%2023.4795C44.4741%2023.4795%2045.2205%2022.7417%2045.2205%2021.7549H45.2236Z'%20fill='black'/%3e%3cpath%20d='M48.0842%2026.5348H49.2611L52.3738%2019.1447H51.1752L49.6637%2022.7844L48.1523%2019.1447H46.9568L49.066%2024.1401L48.0842%2026.5348Z'%20fill='black'/%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_1172_7252'%20x1='66.0036'%20y1='9.49896'%20x2='52.4718'%20y2='9.49896'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%231615FF'%20stop-opacity='0.7'/%3e%3cstop%20offset='0.88'%20stop-color='%23FF99FF'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e", tt = "data:image/webp;base64,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", nt = "data:image/webp;base64,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", at = "data:image/svg+xml,%3csvg%20width='66'%20height='28'%20viewBox='0%200%2066%2028'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M9.71905%204.4948C8.67838%203.75395%207.48905%203.37891%206.16655%203.37891C4.47237%203.37891%203.0043%203.98143%201.80568%205.1711C0.607058%206.36078%200%207.81483%200%209.49943C0%2011.184%200.607058%2012.6381%201.80568%2013.8247C3.0043%2015.0144%204.46927%2015.6169%206.16655%2015.6169C7.48596%2015.6169%208.67838%2015.2418%209.71905%2014.5041V15.2173H11.9274V3.76624H9.71905V4.4948ZM9.71905%2011.264C9.53321%2011.6236%209.28234%2011.9618%208.97262%2012.2692C8.18902%2013.0469%207.26915%2013.4251%206.16655%2013.4251C5.06394%2013.4251%204.14717%2013.05%203.36977%2012.2753C2.58927%2011.5007%202.21141%2010.5938%202.21141%209.49943C2.21141%208.40505%202.58927%207.49512%203.36977%206.72352C4.15026%205.94885%205.06394%205.57381%206.16655%205.57381C7.26915%205.57381%208.18903%205.94885%208.96643%206.71123C9.27615%207.02786%209.53011%207.37216%209.71595%207.7349V11.264H9.71905Z'%20fill='black'/%3e%3cpath%20d='M19.9132%203.37891C18.5937%203.37891%2017.4013%203.75395%2016.3607%204.4948V3.78161H14.1523V19.1367H16.3607V14.5041C17.4013%2015.2449%2018.5906%2015.62%2019.9132%2015.62C21.6073%2015.62%2023.0754%2015.0174%2024.2709%2013.8278C25.4695%2012.6381%2026.0766%2011.184%2026.0766%209.50251C26.0766%207.82098%2025.4695%206.36385%2024.2709%205.17418C23.0723%203.9845%2021.6073%203.38198%2019.9132%203.38198V3.37891ZM19.9132%2013.4251C18.8105%2013.4251%2017.8969%2013.0531%2017.1226%2012.2846C16.8036%2011.9679%2016.5496%2011.6267%2016.3607%2011.264V7.7349C16.5465%207.37523%2016.8005%207.04016%2017.1226%206.72967C17.8969%205.95193%2018.8074%205.57381%2019.9101%205.57381C21.0127%205.57381%2021.9294%205.94885%2022.7068%206.72352C23.4873%207.4982%2023.8652%208.40505%2023.8652%209.49943C23.8652%2010.5938%2023.4873%2011.5037%2022.7068%2012.2753C21.9263%2013.05%2021.0127%2013.4251%2019.9101%2013.4251H19.9132Z'%20fill='black'/%3e%3cpath%20d='M37.6532%205.1711C36.4546%203.98143%2034.9896%203.37891%2033.2955%203.37891C31.6013%203.37891%2030.1332%203.98143%2028.9346%205.1711C27.736%206.36078%2027.1289%207.81483%2027.1289%209.49943C27.1289%2011.184%2027.736%2012.6381%2028.9346%2013.8247C30.1332%2015.0144%2031.5982%2015.6169%2033.2955%2015.6169C34.9927%2015.6169%2036.4577%2015.0144%2037.6532%2013.8247C38.8518%2012.635%2039.4589%2011.181%2039.4589%209.49943C39.4589%207.8179%2038.8518%206.36078%2037.6532%205.1711ZM33.2955%2013.4251C32.1928%2013.4251%2031.2761%2013.05%2030.4987%2012.2753C29.7182%2011.5007%2029.3403%2010.5938%2029.3403%209.49943C29.3403%208.40505%2029.7182%207.49512%2030.4987%206.72352C31.2792%205.94885%2032.1928%205.57381%2033.2955%205.57381C34.3981%205.57381%2035.3148%205.94885%2036.0922%206.72352C36.8727%207.4982%2037.2506%208.40505%2037.2506%209.49943C37.2506%2010.5938%2036.8727%2011.5037%2036.0922%2012.2753C35.3117%2013.05%2034.3981%2013.4251%2033.2955%2013.4251Z'%20fill='black'/%3e%3cpath%20d='M49.9405%2011.9676C49.8538%2012.0722%2049.7639%2012.1736%2049.6679%2012.2689C48.8843%2013.0467%2047.9645%2013.4248%2046.8619%2013.4248C45.7593%2013.4248%2044.8425%2013.0497%2044.0651%2012.2751C43.2846%2011.5004%2042.9067%2010.5935%2042.9067%209.49914C42.9067%208.40477%2043.2846%207.49483%2044.0651%206.72323C44.8456%205.94856%2045.7593%205.57352%2046.8619%205.57352C47.9645%205.57352%2048.8781%205.94549%2049.6617%206.70786C49.7608%206.81546%2049.8538%206.92305%2049.9436%207.03372L50.2595%207.41798L51.9723%206.01312L51.6471%205.63193C51.5232%205.48745%2051.39%205.33682%2051.2289%205.16774C50.0272%203.98421%2048.556%203.38477%2046.8619%203.38477C45.1677%203.38477%2043.6996%203.98729%2042.501%205.17696C41.3024%206.36664%2040.6953%207.82069%2040.6953%209.50529C40.6953%2011.1899%2041.3024%2012.6439%2042.501%2013.8305C43.6996%2015.0202%2045.1646%2015.6227%2046.8619%2015.6227C48.5591%2015.6227%2050.0272%2015.0171%2051.2289%2013.8213C51.3776%2013.6738%2051.517%2013.5231%2051.644%2013.3725L51.9692%2012.9913L50.2564%2011.5865L49.9405%2011.9707V11.9676Z'%20fill='black'/%3e%3cpath%20d='M62.0352%200L52.4648%209.49896L62.0352%2018.9979C67.3191%2013.7535%2067.3191%205.24748%2062.0352%200.0030741V0Z'%20fill='url(%23paint0_linear_1172_7299)'/%3e%3cpath%20d='M24.75%2022.9055H25.7535C25.7535%2023.3112%2026.1159%2023.6586%2026.7012%2023.6586C27.2866%2023.6586%2027.6583%2023.3635%2027.6583%2022.9823C27.6583%2022.6442%2027.3826%2022.4689%2026.9986%2022.3798L26.3048%2022.2169C25.3478%2021.9648%2024.9049%2021.4729%2024.9049%2020.7198C24.9049%2019.8898%2025.6637%2019.2012%2026.7322%2019.2012C27.6118%2019.2012%2028.5596%2019.6592%2028.5596%2020.7321H27.5251C27.5251%2020.3601%2027.141%2020.108%2026.7539%2020.108C26.3017%2020.108%2025.9951%2020.4031%2025.9951%2020.7536C25.9951%2021.0702%2026.2924%2021.2454%2026.6114%2021.3223L27.3919%2021.5067C28.4945%2021.7803%2028.7361%2022.4566%2028.7361%2023.0038C28.7361%2023.9752%2027.7667%2024.5655%2026.7105%2024.5655C25.7535%2024.5655%2024.7717%2023.9752%2024.75%2022.9055Z'%20fill='black'/%3e%3cpath%20d='M32.2315%2019.3301V20.2277H31.1289V24.4361H30.0511V20.2277H29.125V19.3301H30.0511V17.418H31.1289V19.3301H32.2315Z'%20fill='black'/%3e%3cpath%20d='M36.5526%2019.3301H37.6304V24.4331H36.5526V23.6584C36.2553%2024.2824%2035.4283%2024.5653%2034.8894%2024.5653C33.5886%2024.5653%2032.8081%2023.7014%2032.8205%2022.2474V19.3301H33.8983V22.2167C33.8983%2023.059%2034.4062%2023.56%2035.0659%2023.56C35.7256%2023.56%2036.5526%2023.1666%2036.5526%2022.106V19.3301Z'%20fill='black'/%3e%3cpath%20d='M42.8698%2017.418H43.9476V24.4361H42.8698V23.6707C42.5291%2024.2486%2041.7919%2024.5683%2041.0982%2024.5683C39.6982%2024.5683%2038.543%2023.4985%2038.543%2021.8785C38.543%2020.2584%2039.6982%2019.2009%2041.0858%2019.2009C41.8136%2019.2009%2042.5291%2019.5084%2042.8698%2020.0863V17.418ZM42.8574%2021.8662C42.8574%2020.8394%2042.0087%2020.2062%2041.2159%2020.2062C40.3363%2020.2062%2039.6177%2020.9071%2039.6177%2021.8662C39.6177%2022.8253%2040.3332%2023.56%2041.2159%2023.56C42.0986%2023.56%2042.8574%2022.8929%2042.8574%2021.8662Z'%20fill='black'/%3e%3cpath%20d='M44.9648%2017.9445C44.9648%2017.551%2045.3055%2017.2559%2045.702%2017.2559C46.0984%2017.2559%2046.4391%2017.551%2046.4391%2017.9445C46.4391%2018.3379%2046.1077%2018.6331%2045.702%2018.6331C45.2962%2018.6331%2044.9648%2018.3379%2044.9648%2017.9445Z'%20fill='black'/%3e%3cpath%20d='M46.2419%2019.3301H45.1641V24.4331H46.2419V19.3301Z'%20fill='black'/%3e%3cpath%20d='M47.1133%2021.8768C47.1133%2020.2598%2048.346%2019.1992%2049.8109%2019.1992C51.2759%2019.1992%2052.521%2020.2598%2052.521%2021.8768C52.521%2023.4937%2051.2759%2024.5666%2049.8109%2024.5666C48.346%2024.5666%2047.1133%2023.4968%2047.1133%2021.8768ZM51.4401%2021.8768C51.4401%2020.893%2050.6905%2020.2044%2049.8109%2020.2044C48.9313%2020.2044%2048.1911%2020.893%2048.1911%2021.8768C48.1911%2022.8605%2048.9282%2023.5614%2049.8109%2023.5614C50.6936%2023.5614%2051.4401%2022.8728%2051.4401%2021.8768Z'%20fill='black'/%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_1172_7299'%20x1='65.9997'%20y1='9.49896'%20x2='52.4679'%20y2='9.49896'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23644BFF'/%3e%3cstop%20offset='0.13'%20stop-color='%237453FF'/%3e%3cstop%20offset='0.4'%20stop-color='%239F68FF'/%3e%3cstop%20offset='0.76'%20stop-color='%23E48BFF'/%3e%3cstop%20offset='0.89'%20stop-color='%23FF99FF'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e", st = "data:image/webp;base64,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", ot = "data:image/webp;base64,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", rt = "data:image/svg+xml,%3csvg%20width='66'%20height='28'%20viewBox='0%200%2066%2028'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M9.7164%204.56264C8.67569%203.81052%207.48631%203.42978%206.16374%203.42978C4.46948%203.42978%203.00134%204.04146%201.80266%205.24922C0.607082%206.45697%200%207.93312%200%209.64333C0%2011.3535%200.607082%2012.8297%201.80576%2014.0343C3.00443%2015.2421%204.46948%2015.8538%206.16684%2015.8538C7.48631%2015.8538%208.67879%2015.473%209.7195%2014.724V15.4481H11.9279V3.823H9.7195V4.56264H9.7164ZM9.7164%2011.4347C9.53056%2011.7998%209.27968%2012.1431%208.96994%2012.4552C8.18631%2013.2448%207.2664%2013.6286%206.16374%2013.6286C5.06108%2013.6286%204.14426%2013.2479%203.36683%2012.4614C2.58629%2011.675%202.20841%2010.7543%202.20841%209.64333C2.20841%208.53232%202.58629%207.60856%203.36683%206.82523C4.14736%206.03878%205.06108%205.65804%206.16374%205.65804C7.2664%205.65804%208.18631%206.03878%208.96375%206.81275C9.27348%207.13419%209.52747%207.48372%209.71331%207.85198V11.4347H9.7164Z'%20fill='black'/%3e%3cpath%20d='M19.9134%203.42978C18.594%203.42978%2017.4015%203.81052%2016.3608%204.56264V3.83861H14.1523V19.4271H16.3608V14.724C17.4015%2015.4761%2018.5909%2015.8569%2019.9134%2015.8569C21.6077%2015.8569%2023.0758%2015.2452%2024.2714%2014.0374C25.4701%2012.8297%2026.0772%2011.3535%2026.0772%209.64645C26.0772%207.93937%2025.4701%206.4601%2024.2714%205.25234C23.0727%204.04458%2021.6077%203.4329%2019.9134%203.4329V3.42978ZM19.9134%2013.6286C18.8108%2013.6286%2017.897%2013.251%2017.1227%2012.4708C16.8037%2012.1494%2016.5497%2011.8029%2016.3608%2011.4347V7.85198C16.5466%207.48685%2016.8006%207.14668%2017.1227%206.83147C17.897%206.04191%2018.8077%205.65804%2019.9103%205.65804C21.013%205.65804%2021.9298%206.03879%2022.7072%206.82523C23.4878%207.61168%2023.8657%208.53232%2023.8657%209.64333C23.8657%2010.7543%2023.4878%2011.6781%2022.7072%2012.4614C21.9267%2013.2479%2021.013%2013.6286%2019.9103%2013.6286H19.9134Z'%20fill='black'/%3e%3cpath%20d='M37.6498%205.24922C36.4511%204.04146%2034.9861%203.42978%2033.2918%203.42978C31.5976%203.42978%2030.1294%204.04146%2028.9308%205.24922C27.7321%206.45697%2027.125%207.93312%2027.125%209.64333C27.125%2011.3535%2027.7321%2012.8297%2028.9308%2014.0343C30.1294%2015.2421%2031.5945%2015.8538%2033.2918%2015.8538C34.9892%2015.8538%2036.4542%2015.2421%2037.6498%2014.0343C38.8485%2012.8266%2039.4556%2011.3504%2039.4556%209.64333C39.4556%207.93624%2038.8485%206.45697%2037.6498%205.24922ZM33.2918%2013.6286C32.1892%2013.6286%2031.2724%2013.2479%2030.4949%2012.4614C29.7144%2011.675%2029.3365%2010.7543%2029.3365%209.64333C29.3365%208.53232%2029.7144%207.60856%2030.4949%206.82523C31.2755%206.03878%2032.1892%205.65804%2033.2918%205.65804C34.3945%205.65804%2035.3113%206.03878%2036.0887%206.82523C36.8693%207.61168%2037.2472%208.53232%2037.2472%209.64333C37.2472%2010.7543%2036.8693%2011.6781%2036.0887%2012.4614C35.3082%2013.2479%2034.3945%2013.6286%2033.2918%2013.6286Z'%20fill='black'/%3e%3cpath%20d='M49.9401%2012.149C49.8534%2012.2551%2049.7636%2012.3581%2049.6644%2012.4548C48.8808%2013.2444%2047.9609%2013.6282%2046.8582%2013.6282C45.7556%2013.6282%2044.8388%2013.2475%2044.0613%2012.4611C43.2808%2011.6746%2042.9029%2010.754%2042.9029%209.64295C42.9029%208.53194%2043.2808%207.60818%2044.0613%206.82485C44.8419%206.0384%2045.7556%205.65766%2046.8582%205.65766C47.9609%205.65766%2048.8746%206.03528%2049.6583%206.80924C49.7574%206.91847%2049.8503%207.0277%2049.9401%207.14005L50.256%207.53015L51.9689%206.10394L51.6437%205.71696C51.5198%205.57028%2051.3866%205.41736%2051.2255%205.24571C50.0237%204.0442%2048.5525%203.43564%2046.8582%203.43564C45.164%203.43564%2043.6958%204.04732%2042.4972%205.25508C41.2985%206.46283%2040.6914%207.93898%2040.6914%209.64919C40.6914%2011.3594%2041.2985%2012.8356%2042.4972%2014.0402C43.6958%2015.2479%2045.1609%2015.8596%2046.8582%2015.8596C48.5556%2015.8596%2050.0237%2015.2448%2051.2255%2014.0308C51.3742%2013.881%2051.5136%2013.7281%2051.6406%2013.5752L51.9658%2013.1882L50.2529%2011.762L49.937%2012.1521L49.9401%2012.149Z'%20fill='black'/%3e%3cpath%20d='M62.0357%200L52.4648%209.64333L62.0357%2019.2867C67.3198%2013.9625%2067.3198%205.32724%2062.0357%200.00312082V0Z'%20fill='url(%23paint0_linear_1172_7139)'/%3e%3cpath%20d='M32.8112%2019.5914H33.889V24.7718H32.8112V23.8949C32.4798%2024.494%2031.7767%2024.906%2030.9838%2024.906C29.6396%2024.906%2028.4844%2023.7732%2028.4844%2022.1754C28.4844%2020.5776%2029.5746%2019.4573%2031.0272%2019.4573C31.7767%2019.4573%2032.4798%2019.7787%2032.8112%2020.3654V19.5883V19.5914ZM32.7988%2022.1754C32.7988%2021.1768%2031.9718%2020.4777%2031.148%2020.4777C30.2684%2020.4777%2029.5746%2021.2548%2029.5746%2022.1754C29.5746%2023.096%2030.2684%2023.8855%2031.1728%2023.8855C32.0771%2023.8855%2032.8019%2023.1521%2032.8019%2022.1754H32.7988Z'%20fill='black'/%3e%3cpath%20d='M34.7773%2023.2174H35.7808C35.7808%2023.6294%2036.1432%2023.982%2036.7286%2023.982C37.314%2023.982%2037.6856%2023.6824%2037.6856%2023.2955C37.6856%2022.9522%2037.41%2022.7743%2037.0259%2022.6838L36.3321%2022.5184C35.3751%2022.2625%2034.9322%2021.7632%2034.9322%2020.9986C34.9322%2020.1561%2035.691%2019.457%2036.7596%2019.457C37.6392%2019.457%2038.5869%2019.922%2038.5869%2021.0111H37.5524C37.5524%2020.6335%2037.1684%2020.3776%2036.7812%2020.3776C36.329%2020.3776%2036.0224%2020.6772%2036.0224%2021.033C36.0224%2021.3544%2036.3198%2021.5323%2036.6388%2021.6103L37.4193%2021.7975C38.5219%2022.0753%2038.7635%2022.7618%2038.7635%2023.3173C38.7635%2024.3034%2037.794%2024.9026%2036.7379%2024.9026C35.7808%2024.9026%2034.799%2024.3034%2034.7773%2023.2174Z'%20fill='black'/%3e%3cpath%20d='M39.3164%2023.2174H40.3199C40.3199%2023.6294%2040.6823%2023.982%2041.2676%2023.982C41.853%2023.982%2042.2247%2023.6824%2042.2247%2023.2955C42.2247%2022.9522%2041.949%2022.7743%2041.565%2022.6838L40.8712%2022.5184C39.9142%2022.2625%2039.4713%2021.7632%2039.4713%2020.9986C39.4713%2020.1561%2040.2301%2019.457%2041.2986%2019.457C42.1782%2019.457%2043.126%2019.922%2043.126%2021.0111H42.0915C42.0915%2020.6335%2041.7075%2020.3776%2041.3203%2020.3776C40.8681%2020.3776%2040.5615%2020.6772%2040.5615%2021.033C40.5615%2021.3544%2040.8588%2021.5323%2041.1778%2021.6103L41.9583%2021.7975C43.0609%2022.0753%2043.3025%2022.7618%2043.3025%2023.3173C43.3025%2024.3034%2042.3331%2024.9026%2041.2769%2024.9026C40.3199%2024.9026%2039.3381%2024.3034%2039.3164%2023.2174Z'%20fill='black'/%3e%3cpath%20d='M49.0642%2022.6191H44.9666C45.109%2023.4616%2045.7254%2023.8954%2046.5523%2023.8954C47.1594%2023.8954%2047.72%2023.6177%2048.0049%2023.1402L48.8628%2023.574C48.4107%2024.4384%2047.4877%2024.9065%2046.5059%2024.9065C45.0192%2024.9065%2043.8516%2023.808%2043.8516%2022.1666C43.8516%2020.5251%2045.0409%2019.4609%2046.5059%2019.4609C47.9708%2019.4609%2049.0828%2020.5251%2049.0828%2022.1572C49.0828%2022.3008%2049.0704%2022.4568%2049.0611%2022.6222L49.0642%2022.6191ZM48.008%2021.7421C47.8965%2020.9308%2047.3142%2020.4658%2046.5214%2020.4658C45.7285%2020.4658%2045.1338%2020.8777%2044.9789%2021.7421H48.008Z'%20fill='black'/%3e%3cpath%20d='M52.5088%2019.5914V20.4996H51.4062V24.7718H50.3284V20.4996H49.4023V19.5914H50.3284V17.6504H51.4062V19.5914H52.5088Z'%20fill='black'/%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_1172_7139'%20x1='66.0003'%20y1='9.64334'%20x2='52.4679'%20y2='9.64334'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%231615FF'%20stop-opacity='0.7'/%3e%3cstop%20offset='0.88'%20stop-color='%23FF99FF'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e", lt = "data:image/webp;base64,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", ct = "data:image/webp;base64,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", it = "data:image/svg+xml,%3csvg%20width='66'%20height='28'%20viewBox='0%200%2066%2028'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M9.71905%204.52859C8.67838%203.78216%207.48905%203.4043%206.16655%203.4043C4.47237%203.4043%203.0043%204.01135%201.80568%205.20997C0.607058%206.40859%200%207.87357%200%209.57084C0%2011.2681%200.607058%2012.7331%201.80568%2013.9286C3.0043%2015.1272%204.46927%2015.7343%206.16655%2015.7343C7.48596%2015.7343%208.67838%2015.3564%209.71905%2014.6131V15.3317H11.9274V3.79454H9.71905V4.52859ZM9.71905%2011.3486C9.53321%2011.711%209.28234%2012.0517%208.97262%2012.3614C8.18902%2013.145%207.26915%2013.526%206.16655%2013.526C5.06394%2013.526%204.14717%2013.1481%203.36977%2012.3676C2.58927%2011.5871%202.21141%2010.6734%202.21141%209.57084C2.21141%208.46824%202.58927%207.55146%203.36977%206.77406C4.15026%205.99357%205.06394%205.6157%206.16655%205.6157C7.26915%205.6157%208.18903%205.99356%208.96643%206.76167C9.27615%207.08068%209.53011%207.42757%209.71595%207.79304V11.3486H9.71905Z'%20fill='black'/%3e%3cpath%20d='M19.9131%203.4043C18.5937%203.4043%2017.4013%203.78216%2016.3607%204.52859V3.81003H14.1523V19.2806H16.3607V14.6131C17.4013%2015.3595%2018.5906%2015.7374%2019.9131%2015.7374C21.6073%2015.7374%2023.0754%2015.1303%2024.2709%2013.9317C25.4695%2012.7331%2026.0766%2011.2681%2026.0766%209.57394C26.0766%207.87976%2025.4695%206.41169%2024.2709%205.21307C23.0723%204.01445%2021.6073%203.40739%2019.9131%203.40739V3.4043ZM19.9131%2013.526C18.8105%2013.526%2017.8969%2013.1512%2017.1226%2012.3769C16.8036%2012.0579%2016.5496%2011.7141%2016.3607%2011.3486V7.79304C16.5465%207.43067%2016.8005%207.09307%2017.1226%206.78025C17.8969%205.99666%2018.8074%205.6157%2019.9101%205.6157C21.0127%205.6157%2021.9294%205.99357%2022.7068%206.77406C23.4873%207.55456%2023.8652%208.46824%2023.8652%209.57084C23.8652%2010.6734%2023.4873%2011.5902%2022.7068%2012.3676C21.9263%2013.1481%2021.0127%2013.526%2019.9101%2013.526H19.9131Z'%20fill='black'/%3e%3cpath%20d='M37.6532%205.20997C36.4546%204.01135%2034.9896%203.4043%2033.2955%203.4043C31.6013%203.4043%2030.1332%204.01135%2028.9346%205.20997C27.736%206.40859%2027.1289%207.87357%2027.1289%209.57084C27.1289%2011.2681%2027.736%2012.7331%2028.9346%2013.9286C30.1332%2015.1272%2031.5982%2015.7343%2033.2955%2015.7343C34.9927%2015.7343%2036.4577%2015.1272%2037.6532%2013.9286C38.8518%2012.73%2039.4589%2011.265%2039.4589%209.57084C39.4589%207.87667%2038.8518%206.40859%2037.6532%205.20997ZM33.2955%2013.526C32.1928%2013.526%2031.2761%2013.1481%2030.4987%2012.3676C29.7182%2011.5871%2029.3403%2010.6734%2029.3403%209.57084C29.3403%208.46824%2029.7182%207.55146%2030.4987%206.77406C31.2792%205.99357%2032.1928%205.6157%2033.2955%205.6157C34.3981%205.6157%2035.3148%205.99357%2036.0922%206.77406C36.8727%207.55456%2037.2506%208.46824%2037.2506%209.57084C37.2506%2010.6734%2036.8727%2011.5902%2036.0922%2012.3676C35.3117%2013.1481%2034.3981%2013.526%2033.2955%2013.526Z'%20fill='black'/%3e%3cpath%20d='M49.9405%2012.0575C49.8538%2012.1628%2049.7639%2012.265%2049.6679%2012.361C48.8843%2013.1446%2047.9645%2013.5255%2046.8618%2013.5255C45.7592%2013.5255%2044.8425%2013.1477%2044.0651%2012.3672C43.2846%2011.5867%2042.9067%2010.673%2042.9067%209.5704C42.9067%208.4678%2043.2846%207.55102%2044.0651%206.77362C44.8456%205.99313%2045.7592%205.61526%2046.8618%205.61526C47.9645%205.61526%2048.8781%205.99003%2049.6617%206.75814C49.7608%206.86654%2049.8538%206.97494%2049.9436%207.08644L50.2595%207.47359L51.9722%206.05817L51.647%205.67411C51.5232%205.52854%2051.39%205.37678%2051.2289%205.20644C50.0272%204.01401%2048.556%203.41005%2046.8618%203.41005C45.1677%203.41005%2043.6996%204.01711%2042.501%205.21573C41.3024%206.41435%2040.6953%207.87932%2040.6953%209.57659C40.6953%2011.2739%2041.3024%2012.7388%2042.501%2013.9344C43.6996%2015.133%2045.1646%2015.74%2046.8618%2015.74C48.5591%2015.74%2050.0272%2015.1299%2051.2289%2013.9251C51.3776%2013.7764%2051.517%2013.6247%2051.6439%2013.4729L51.9691%2013.0888L50.2564%2011.6734L49.9405%2012.0606V12.0575Z'%20fill='black'/%3e%3cpath%20d='M62.0391%200L52.4688%209.57038L62.0391%2019.1408C67.323%2013.8569%2067.323%205.28694%2062.0391%200.00310023V0Z'%20fill='url(%23paint0_linear_1172_7196)'/%3e%3cpath%20d='M19.8754%2020.0578C20.1882%2020.0578%2020.4794%2020.1848%2020.6745%2020.4016L20.7024%2020.4326L21.2289%2019.9339L21.2041%2019.9061C20.8913%2019.5251%2020.402%2019.3083%2019.863%2019.3083C18.8038%2019.3083%2018.0078%2020.095%2018.0078%2021.1388C18.0078%2022.1825%2018.8069%2022.9754%2019.863%2022.9754C20.402%2022.9754%2020.8913%2022.7586%2021.2041%2022.3776L21.2289%2022.3498L20.7024%2021.8511L20.6745%2021.8821C20.4794%2022.102%2020.1882%2022.2259%2019.8754%2022.2259C19.256%2022.2259%2018.7914%2021.7582%2018.7914%2021.1419C18.7914%2020.5255%2019.2591%2020.064%2019.8754%2020.064V20.0578Z'%20fill='black'/%3e%3cpath%20d='M23.1611%2019.3045C22.1329%2019.3045%2021.3555%2020.0912%2021.3555%2021.135C21.3555%2022.1787%2022.1329%2022.9716%2023.1611%2022.9716C24.1894%2022.9716%2024.973%2022.1818%2024.973%2021.135C24.973%2020.0881%2024.1925%2019.3045%2023.1611%2019.3045ZM23.1611%2022.219C22.5789%2022.219%2022.1422%2021.7513%2022.1422%2021.135C22.1422%2020.5186%2022.582%2020.0571%2023.1611%2020.0571C23.7403%2020.0571%2024.1894%2020.531%2024.1894%2021.135C24.1894%2021.7389%2023.7465%2022.219%2023.1611%2022.219Z'%20fill='black'/%3e%3cpath%20d='M29.5738%2019.3045C29.3322%2019.3045%2028.753%2019.3726%2028.4216%2019.9704C28.2048%2019.5523%2027.796%2019.3045%2027.3159%2019.3045C26.8916%2019.3045%2026.4982%2019.5027%2026.3031%2019.8032V19.3912H25.5195V22.8818H26.3031V21.008C26.3031%2020.3142%2026.7584%2020.0695%2027.1518%2020.0695C27.5451%2020.0695%2027.8177%2020.4071%2027.8177%2020.9274V22.8818H28.6105V21.1412C28.6105%2020.7385%2028.7004%2020.4443%2028.88%2020.2646C29.0132%2020.1315%2029.1897%2020.0664%2029.4158%2020.0695C29.8494%2020.0695%2030.1189%2020.3978%2030.1189%2020.9274V22.8818H30.9118V20.8934C30.9118%2019.8837%2030.4255%2019.3045%2029.5738%2019.3045Z'%20fill='black'/%3e%3cpath%20d='M35.6871%2019.3045C35.4455%2019.3045%2034.8663%2019.3726%2034.5349%2019.9704C34.3181%2019.5523%2033.9093%2019.3045%2033.4292%2019.3045C33.0049%2019.3045%2032.6115%2019.5027%2032.4164%2019.8032V19.3912H31.6328V22.8818H32.4164V21.008C32.4164%2020.3142%2032.8717%2020.0695%2033.265%2020.0695C33.6584%2020.0695%2033.9309%2020.4071%2033.9309%2020.9274V22.8818H34.7238V21.1412C34.7238%2020.7385%2034.8136%2020.4443%2034.9933%2020.2646C35.1265%2020.1315%2035.303%2020.0664%2035.5291%2020.0695C35.9627%2020.0695%2036.2322%2020.3978%2036.2322%2020.9274V22.8818H37.0251V20.8934C37.0251%2019.8837%2036.5388%2019.3045%2035.6871%2019.3045Z'%20fill='black'/%3e%3cpath%20d='M40.1282%2021.2871C40.1282%2021.9313%2039.6605%2022.2194%2039.1959%2022.2194C38.7623%2022.2194%2038.4711%2021.8756%2038.4711%2021.3614V19.3947H37.6875V21.3831C37.6845%2021.8972%2037.8269%2022.3185%2038.0964%2022.5941C38.338%2022.8388%2038.6787%2022.9689%2039.0813%2022.9689C39.4406%2022.9689%2039.899%2022.7954%2040.1313%2022.4671V22.8791H40.9148V19.3885H40.1313V21.284L40.1282%2021.2871Z'%20fill='black'/%3e%3cpath%20d='M43.496%2019.3045C43.1925%2019.3045%2042.6938%2019.4408%2042.4399%2019.8094V19.3912H41.6562V22.8818H42.4399V21.008C42.4399%2020.3266%2042.9416%2020.085%2043.3721%2020.085C43.8026%2020.085%2044.0969%2020.4257%2044.0969%2020.9367V22.8818H44.8804V20.8934C44.8835%2020.3761%2044.7442%2019.9549%2044.4716%2019.6793C44.2331%2019.4346%2043.8955%2019.3076%2043.4929%2019.3076L43.496%2019.3045Z'%20fill='black'/%3e%3cpath%20d='M45.9805%2017.6912C45.6924%2017.6912%2045.457%2017.9142%2045.457%2018.1899C45.457%2018.4655%2045.6924%2018.6885%2045.9805%2018.6885C46.2685%2018.6885%2046.5039%2018.4686%2046.5039%2018.1899C46.5039%2017.9111%2046.2747%2017.6912%2045.9805%2017.6912Z'%20fill='black'/%3e%3cpath%20d='M46.3695%2019.3944H45.5859V22.8849H46.3695V19.3944Z'%20fill='black'/%3e%3cpath%20d='M48.1485%2018.1151H47.3618V19.3942H46.7578V20.0725H47.3618V22.8817H48.1485V20.0725H48.8701V19.3942H48.1485V18.1151Z'%20fill='black'/%3e%3cpath%20d='M51.7286%2019.3944L50.7871%2021.7018L49.8579%2019.4191L49.8486%2019.3944H49L50.3628%2022.6898L49.6194%2024.5419H50.4526L52.5773%2019.3944H51.7286Z'%20fill='black'/%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_1172_7196'%20x1='66.0035'%20y1='9.57038'%20x2='52.4688'%20y2='9.57038'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%231615FF'%20stop-opacity='0.7'/%3e%3cstop%20offset='0.88'%20stop-color='%23FF99FF'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e", ut = "data:image/svg+xml,%3csvg%20width='20'%20height='20'%20viewBox='0%200%2020%2020'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M9.99969%2017.5836C8.95589%2017.5836%207.97326%2017.386%207.0518%2016.9907C6.13033%2016.5954%205.32503%2016.0532%204.63592%2015.3641C3.94683%2014.675%203.40463%2013.8697%203.00934%2012.9482C2.61403%2012.0267%202.41638%2011.0441%202.41638%2010.0003C2.41638%208.94796%202.61403%207.96319%203.00934%207.04599C3.40463%206.1288%203.94683%205.32565%204.63592%204.63653C5.32503%203.94744%206.13033%203.40524%207.0518%203.00995C7.97326%202.61465%208.95589%202.41699%209.99969%202.41699C11.052%202.41699%2012.0368%202.61465%2012.954%203.00995C13.8712%203.40524%2014.6744%203.94744%2015.3635%204.63653C16.0526%205.32565%2016.5948%206.1288%2016.99%207.04599C17.3854%207.96319%2017.583%208.94796%2017.583%2010.0003C17.583%2011.0441%2017.3854%2012.0267%2016.99%2012.9482C16.5948%2013.8697%2016.0526%2014.675%2015.3635%2015.3641C14.6744%2016.0532%2013.8712%2016.5954%2012.954%2016.9907C12.0368%2017.386%2011.052%2017.5836%209.99969%2017.5836ZM9.99969%2016.4618C10.2999%2016.1616%2010.5814%2015.6726%2010.8443%2014.9947C11.1071%2014.3168%2011.309%2013.5612%2011.45%2012.7278H8.54936C8.70107%2013.5826%208.90567%2014.3489%209.16315%2015.0267C9.42062%2015.7046%209.69947%2016.183%209.99969%2016.4618ZM8.65678%2016.3577C8.39289%2015.941%208.15464%2015.4164%207.94203%2014.784C7.72942%2014.1515%207.56649%2013.4661%207.45324%2012.7278H4.10544C4.54562%2013.6905%205.16716%2014.4904%205.97005%2015.1277C6.77295%2015.765%207.66853%2016.175%208.65678%2016.3577ZM11.3426%2016.3577C12.3309%2016.175%2013.2264%2015.765%2014.0293%2015.1277C14.8322%2014.4904%2015.4538%2013.6905%2015.8939%2012.7278H12.5462C12.4062%2013.4714%2012.2299%2014.1595%2012.0173%2014.792C11.8047%2015.4245%2011.5798%2015.9464%2011.3426%2016.3577ZM3.72726%2011.6446H7.34586C7.3074%2011.3486%207.28337%2011.0588%207.27376%2010.7752C7.26415%2010.4915%207.25934%2010.2193%207.25934%209.95864C7.25934%209.69796%207.26415%209.43273%207.27376%209.16295C7.28337%208.89319%207.3074%208.62422%207.34586%208.35606H3.72726C3.64713%208.62529%203.58917%208.8988%203.55338%209.17658C3.51759%209.45435%203.49969%209.72893%203.49969%2010.0003C3.49969%2010.2717%203.51759%2010.5463%203.55338%2010.824C3.58917%2011.1018%203.64713%2011.3753%203.72726%2011.6446ZM8.45001%2011.6446H11.5494C11.5878%2011.3347%2011.6119%2011.0476%2011.6215%2010.7832C11.6311%2010.5187%2011.6359%2010.2578%2011.6359%2010.0003C11.6359%209.74282%2011.6311%209.4784%2011.6215%209.20703C11.6119%208.93566%2011.5878%208.652%2011.5494%208.35606H8.45001C8.41155%208.652%208.38751%208.93566%208.37788%209.20703C8.36827%209.4784%208.36347%209.74282%208.36347%2010.0003C8.36347%2010.2578%208.36827%2010.5222%208.37788%2010.7936C8.38751%2011.065%208.41155%2011.3486%208.45001%2011.6446ZM12.6535%2011.6446H16.2721C16.3523%2011.3753%2016.4102%2011.1018%2016.446%2010.824C16.4818%2010.5463%2016.4997%2010.2717%2016.4997%2010.0003C16.4997%209.72893%2016.4818%209.45088%2016.446%209.16616C16.4102%208.88144%2016.3523%208.6114%2016.2721%208.35606H12.6535C12.692%208.652%2012.716%208.9418%2012.7256%209.22545C12.7352%209.50912%2012.74%209.78129%2012.74%2010.042C12.74%2010.3027%2012.7352%2010.5679%2012.7256%2010.8377C12.716%2011.1074%2012.692%2011.3764%2012.6535%2011.6446ZM12.5462%207.27276H15.8939C15.4484%206.29946%2014.8309%205.4995%2014.0414%204.87289C13.2518%204.24629%2012.3522%203.83363%2011.3426%203.63491C11.6065%204.07828%2011.8421%204.61221%2012.0493%205.23668C12.2566%205.86115%2012.4222%206.53985%2012.5462%207.27276ZM8.54936%207.27276H11.45C11.2983%206.4234%2011.0897%205.6531%2010.8242%204.96185C10.5587%204.27061%2010.2839%203.79625%209.99969%203.53876C9.7155%203.79625%209.44066%204.27061%209.17517%204.96185C8.90967%205.6531%208.70107%206.4234%208.54936%207.27276ZM4.10544%207.27276H7.45324C7.57717%206.53985%207.74277%205.86115%207.95005%205.23668C8.15731%204.61221%208.39289%204.07828%208.65678%203.63491C7.64182%203.83363%206.7409%204.24763%205.95403%204.87691C5.16717%205.50619%204.55097%206.30481%204.10544%207.27276Z'%20fill='%23332C5C'/%3e%3c/svg%3e", dt = "data:image/svg+xml,%3csvg%20width='30'%20height='24'%20viewBox='0%200%2030%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M0%202C0%200.895431%200.895431%200%202%200H28C29.1046%200%2030%200.895431%2030%202C30%203.10457%2029.1046%204%2028%204H2C0.89543%204%200%203.10457%200%202Z'%20fill='url(%23paint0_linear_99_56)'/%3e%3cpath%20d='M0%2012C0%2010.8954%200.895431%2010%202%2010H28C29.1046%2010%2030%2010.8954%2030%2012C30%2013.1046%2029.1046%2014%2028%2014H2C0.89543%2014%200%2013.1046%200%2012Z'%20fill='url(%23paint1_linear_99_56)'/%3e%3cpath%20d='M0%2022C0%2020.8954%200.895431%2020%202%2020H28C29.1046%2020%2030%2020.8954%2030%2022C30%2023.1046%2029.1046%2024%2028%2024H2C0.89543%2024%200%2023.1046%200%2022Z'%20fill='url(%23paint2_linear_99_56)'/%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_99_56'%20x1='31.4'%20y1='4'%20x2='20.4993'%20y2='-15.9829'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23FF99FF'%20stop-opacity='0.9'/%3e%3cstop%20offset='0.345'%20stop-color='%23A473FF'/%3e%3cstop%20offset='0.675473'%20stop-color='%23835EFF'/%3e%3cstop%20offset='1'%20stop-color='%23644BFF'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear_99_56'%20x1='31.4'%20y1='14'%20x2='20.4993'%20y2='-5.98286'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23FF99FF'%20stop-opacity='0.9'/%3e%3cstop%20offset='0.345'%20stop-color='%23A473FF'/%3e%3cstop%20offset='0.675473'%20stop-color='%23835EFF'/%3e%3cstop%20offset='1'%20stop-color='%23644BFF'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint2_linear_99_56'%20x1='31.4'%20y1='24'%20x2='20.4993'%20y2='4.01714'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23FF99FF'%20stop-opacity='0.9'/%3e%3cstop%20offset='0.345'%20stop-color='%23A473FF'/%3e%3cstop%20offset='0.675473'%20stop-color='%23835EFF'/%3e%3cstop%20offset='1'%20stop-color='%23644BFF'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e", ft = "data:image/svg+xml,%3csvg%20width='20'%20height='20'%20viewBox='0%200%2020%2020'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M17.2583%2016.075L14.425%2013.25C15.3392%2012.0854%2015.8352%2010.6472%2015.8333%209.16667C15.8333%207.84812%2015.4423%206.55919%2014.7098%205.46287C13.9773%204.36654%2012.9361%203.51205%2011.7179%203.00747C10.4997%202.50289%209.15927%202.37086%207.86607%202.6281C6.57286%202.88533%205.38497%203.52027%204.45262%204.45262C3.52027%205.38497%202.88534%206.57286%202.6281%207.86607C2.37087%209.15927%202.50289%2010.4997%203.00747%2011.7179C3.51206%2012.9361%204.36654%2013.9773%205.46287%2014.7098C6.5592%2015.4423%207.84813%2015.8333%209.16667%2015.8333C10.6472%2015.8352%2012.0854%2015.3392%2013.25%2014.425L16.075%2017.2583C16.1525%2017.3364%2016.2446%2017.3984%2016.3462%2017.4407C16.4477%2017.4831%2016.5567%2017.5048%2016.6667%2017.5048C16.7767%2017.5048%2016.8856%2017.4831%2016.9872%2017.4407C17.0887%2017.3984%2017.1809%2017.3364%2017.2583%2017.2583C17.3364%2017.1809%2017.3984%2017.0887%2017.4407%2016.9871C17.4831%2016.8856%2017.5048%2016.7767%2017.5048%2016.6667C17.5048%2016.5567%2017.4831%2016.4477%2017.4407%2016.3462C17.3984%2016.2446%2017.3364%2016.1525%2017.2583%2016.075ZM4.16667%209.16667C4.16667%208.17776%204.45991%207.21106%205.00932%206.38882C5.55873%205.56657%206.33962%204.92571%207.25325%204.54727C8.16688%204.16883%209.17222%204.06981%2010.1421%204.26274C11.112%204.45567%2012.0029%204.93187%2012.7022%205.63113C13.4015%206.3304%2013.8777%207.22131%2014.0706%208.19122C14.2635%209.16112%2014.1645%2010.1665%2013.7861%2011.0801C13.4076%2011.9937%2012.7668%2012.7746%2011.9445%2013.324C11.1223%2013.8734%2010.1556%2014.1667%209.16667%2014.1667C7.84059%2014.1667%206.56882%2013.6399%205.63114%2012.7022C4.69345%2011.7645%204.16667%2010.4927%204.16667%209.16667Z'%20fill='%23332C5C'/%3e%3c/svg%3e", mt = "data:image/svg+xml,%3csvg%20width='36'%20height='36'%20viewBox='0%200%2036%2036'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M30.6057%2027.713L26.0739%2023.1945C27.536%2021.3317%2028.3294%2019.0313%2028.3265%2016.6632C28.3265%2014.5542%2027.7011%2012.4926%2026.5294%2010.7391C25.3577%208.98549%2023.6923%207.61876%2021.7439%206.81169C19.7954%206.00461%2017.6514%205.79345%2015.5829%206.20489C13.5145%206.61633%2011.6145%207.63191%2010.1232%209.12318C8.63191%2010.6145%207.61634%2012.5145%207.2049%2014.5829C6.79345%2016.6514%207.00462%2018.7954%207.81169%2020.7439C8.61877%2022.6923%209.9855%2024.3577%2011.7391%2025.5294C13.4926%2026.7011%2015.5542%2027.3265%2017.6632%2027.3265C20.0313%2027.3294%2022.3317%2026.536%2024.1945%2025.0738L28.713%2029.6057C28.8369%2029.7307%2028.9843%2029.8298%2029.1468%2029.8975C29.3092%2029.9652%2029.4834%2030%2029.6594%2030C29.8353%2030%2030.0095%2029.9652%2030.172%2029.8975C30.3344%2029.8298%2030.4818%2029.7307%2030.6057%2029.6057C30.7307%2029.4818%2030.8298%2029.3344%2030.8975%2029.172C30.9652%2029.0095%2031%2028.8353%2031%2028.6594C31%2028.4834%2030.9652%2028.3092%2030.8975%2028.1468C30.8298%2027.9843%2030.7307%2027.8369%2030.6057%2027.713ZM9.66581%2016.6632C9.66581%2015.0815%2010.1349%2013.5353%2011.0136%2012.2201C11.8924%2010.9049%2013.1414%209.87988%2014.6028%209.27457C16.0641%208.66927%2017.6721%208.51089%2019.2235%208.81947C20.7748%209.12805%2022.1998%209.88974%2023.3183%2011.0082C24.4367%2012.1267%2025.1984%2013.5517%2025.507%2015.103C25.8156%2016.6544%2025.6572%2018.2624%2025.0519%2019.7237C24.4466%2021.185%2023.4215%2022.4341%2022.1064%2023.3128C20.7912%2024.1916%2019.245%2024.6606%2017.6632%2024.6606C15.5422%2024.6606%2013.508%2023.8181%2012.0082%2022.3183C10.5084%2020.8184%209.66581%2018.7843%209.66581%2016.6632Z'%20fill='%23644BFF'/%3e%3c/svg%3e", Ct = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='icon_placeholder'%20clip-path='url(%23clip0_17721_17393)'%3e%3cg%20id='icon_check'%3e%3cpath%20id='Vector'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M20.5511%206.42983C21.1421%207.01031%2021.1507%207.96002%2020.5702%208.55106L10.2577%2019.0511C9.97563%2019.3382%209.59001%2019.5%209.1875%2019.5C8.78499%2019.5%208.39937%2019.3382%208.11733%2019.0511L3.42983%2014.2783C2.84934%2013.6873%202.8579%2012.7376%203.44894%2012.1571C4.03998%2011.5766%204.98969%2011.5852%205.57017%2012.1762L9.1875%2015.8593L18.4298%206.44894C19.0103%205.8579%2019.96%205.84934%2020.5511%206.42983Z'%20fill='%23644BFF'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_17721_17393'%3e%3crect%20width='24'%20height='24'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", pt = "data:image/svg+xml,%3csvg%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M3.33335%205.6665L8.00002%2010.3332L12.6667%205.6665'%20stroke='%23393939'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", gt = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M21.9095%2019.9997L27.6786%2025.7689L28.8684%2026.9586C29.0439%2027.1341%2029.0439%2027.4193%2028.8684%2027.5948L27.5954%2028.8678C27.4199%2029.0433%2027.1347%2029.0433%2026.9592%2028.8678L20.0003%2021.9089L13.0414%2028.8684C12.8659%2029.0439%2012.5807%2029.0439%2012.4052%2028.8684L11.1316%2027.5954C10.9561%2027.4199%2010.9561%2027.1347%2011.1316%2026.9592L18.0911%2019.9997L11.1316%2013.0408C10.9561%2012.8653%2010.9561%2012.5801%2011.1316%2012.4046L12.4046%2011.1316C12.5801%2010.9561%2012.8653%2010.9561%2013.0408%2011.1316L20.0003%2018.0905L25.7695%2012.3214L26.9592%2011.1316C27.1347%2010.9561%2027.4199%2010.9561%2027.5954%2011.1316L28.8684%2012.4046C29.0439%2012.5801%2029.0439%2012.8653%2028.8684%2013.0408L21.9095%2019.9997Z'%20fill='black'/%3e%3c/svg%3e", Q = {
  apocLogo: z1,
  playLogoPc: _1,
  playLogoTb: $1,
  playLogoMb: et,
  studioLogoPc: tt,
  studioLogoTb: nt,
  studioLogoMb: at,
  assetLogoPc: st,
  assetLogoTb: ot,
  assetLogoMb: rt,
  commLogoPc: lt,
  commLogoTb: ct,
  commLogoMb: it,
  language: ut,
  hamburger: dt,
  search: ft,
  barSearch: mt,
  checkIcon: Ct,
  downArrow: pt,
  spaceX: gt
};
var v0 = /* @__PURE__ */ ((e) => (e.SEARCH_BAR_CONTROLLER = "apoc-mega-menu:search-bar-controller", e))(v0 || {});
const ue = {
  [y2.LOCAL]: {
    [b.APOC]: "https://brand.apoc.day/",
    [b.PLAY]: "https://localhost:4000/",
    [b.STUDIO]: "https://localhost:4001/#/",
    [b.ASSET]: "http://localhost:4002/",
    [b.COMM]: "http://localhost:4003/",
    [b.MY]: "http://localhost:4500/",
    [b.SSO]: "https://sso-dev.apoc.day/"
  },
  [y2.DEV]: {
    [b.APOC]: "https://brand.apoc.day/",
    [b.PLAY]: "https://dev.apoc.day/",
    [b.STUDIO]: "https://studio-dev.apoc.day/#/",
    [b.ASSET]: "https://asset-dev.apoc.day/",
    [b.COMM]: "https://community-dev.apoc.day/",
    [b.MY]: "https://my-dev.apoc.day/",
    [b.SSO]: "https://sso-dev.apoc.day/"
  },
  [y2.STAGE]: {
    [b.APOC]: "https://brand.apoc.day/",
    [b.PLAY]: "https://stage.apoc.day/",
    [b.STUDIO]: "https://studio-stage.apoc.day/#/",
    [b.ASSET]: "https://asset-stage.apoc.day/",
    [b.COMM]: "https://comm.apoc.day/",
    [b.MY]: "https://my-stage.apoc.day/",
    [b.SSO]: "https://sso-stage.apoc.day/"
  },
  [y2.DEMO]: {
    [b.APOC]: "https://brand-demo.apoc.day/",
    [b.PLAY]: "https://demo.apoc.day/",
    [b.STUDIO]: "https://studio-demo.apoc.day/#/",
    [b.ASSET]: "https://asset-demo.apoc.day/",
    [b.COMM]: "https://comm-demo.apoc.day/",
    [b.MY]: "https://my-demo.apoc.day/",
    [b.SSO]: "https://sso-demo.apoc.day/"
  },
  [y2.PROD]: {
    [b.APOC]: "https://brand.apoc.day/",
    [b.PLAY]: "https://www.apoc.day/",
    [b.STUDIO]: "https://studio.apoc.day/#/",
    [b.ASSET]: "https://asset.apoc.day/",
    [b.COMM]: "https://comm.apoc.day/",
    [b.MY]: "https://my.apoc.day/",
    [b.SSO]: "https://sso.apoc.day/"
  }
}, f0 = (e, t) => ue[e][t], ht = ne({
  name: "ApocSvg",
  props: {
    src: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const t = j(null), a = () => {
      if (t.value) {
        const n = new XMLHttpRequest();
        n.open("GET", e.src, !0), n.onload = () => {
          if (n.status === 200) {
            const u = new DOMParser().parseFromString(n.responseText, "text/xml").getElementsByTagName("svg")[0];
            if (!u) {
              console.error(`svg element not found
${n.responseURL}`);
              return;
            }
            t.value && t.value.appendChild(u);
          } else n.status === 404 ? console.error(`svg src not found.
${n.responseURL}`) : console.error(`error!
${n.responseURL}
status ${n.status}`);
        }, n.onerror = () => {
          console.error("XML Http Request error");
        }, n.send();
      }
    };
    return b0(() => {
      a();
    }), {
      parentElement: t
    };
  }
}), At = (e, t) => {
  const a = e.__vccOpts || e;
  for (const [n, r] of t)
    a[n] = r;
  return a;
}, vt = {
  class: "apoc-svg",
  ref: "parentElement"
};
function bt(e, t, a, n, r, s) {
  return V(), W("div", vt, null, 512);
}
const N2 = /* @__PURE__ */ At(ht, [["render", bt]]), Lt = { class: "amm-wrapper" }, kt = { class: "left-area" }, wt = { key: 0 }, yt = { key: 1 }, Mt = ["src"], St = ["src"], Ft = ["src"], It = ["src"], Ot = ["src"], Et = ["src"], Ht = ["src"], Tt = ["src"], Nt = ["src"], Pt = ["src"], Rt = ["src"], Vt = ["src"], Wt = ["src"], Bt = ["src"], Ut = { class: "middle-area" }, Dt = { key: 0 }, Zt = { key: 1 }, xt = ["onClick"], Qt = { class: "sub-menu-list" }, Kt = ["onClick"], Jt = ["onClick"], Gt = { key: 0 }, Yt = { key: 1 }, jt = { class: "amm-option-list-area-wrapper" }, qt = { class: "amm-option-list-area" }, Xt = ["value", "onClick"], zt = { class: "amm-option-list-desc" }, _t = ["src"], $t = {
  key: 0,
  class: "amm-content"
}, e3 = { class: "amm-search-bar" }, t3 = ["placeholder"], n3 = { class: "amm-search-bar" }, a3 = ["placeholder"], s3 = { class: "close-wrapper" }, o3 = {
  key: 0,
  class: "amm-link apoc"
}, r3 = ["src"], l3 = {
  key: 1,
  class: "amm-link play"
}, c3 = ["src"], i3 = {
  key: 2,
  class: "amm-link studio"
}, u3 = ["src"], d3 = {
  key: 3,
  class: "amm-link asset"
}, f3 = ["src"], m3 = {
  key: 4,
  class: "amm-link comm"
}, C3 = ["src"], p3 = ["onClick"], g3 = ["onClick"], h3 = ["onClick"], A3 = ["onClick"], v3 = /* @__PURE__ */ ne({
  __name: "ApocMegaMenu",
  props: {
    config: {
      type: Object,
      required: !0
    },
    isLogin: {
      type: Boolean,
      required: !1,
      default: !1
    },
    path: {
      type: String,
      required: !1
    }
  },
  emits: ["onEnterKeyword", "onChangeLang", "onClickLogin", "onClickStudioMake", "onClickSearch", "onClickLogo", "onFocusInSearch"],
  setup(e, { emit: t }) {
    const a = e, n = t, r = j(null), s = O0(a, "config"), u = O0(a, "path"), i = j(!1), C = w2(() => s.value.serviceType), h = w2(() => a.isLogin), w = pe(), M = j(0), { t: v, locale: B } = D1({
      legacy: !1,
      missingWarn: !1,
      fallbackWarn: !1,
      warnHtmlMessage: !1,
      useScope: "global",
      // locale: 'en',
      messages: {
        ko: G1,
        en: X1
      }
    }), L = j(!1), I = j(!1), y = j(!1), c = j(C.value), g = j(void 0), A = j(s.value.lang), f = [b.PLAY, b.ASSET, b.COMM];
    b.PLAY, b.ASSET, b.COMM;
    const F = () => {
      s.value.sideBarLocation || (s.value.sideBarLocation = P2.sideBarLocation), (s.value.alwaysSearchbarOpen === null || s.value.alwaysSearchbarOpen === void 0) && (s.value.alwaysSearchbarOpen = !1);
    }, S = () => {
      I.value = !I.value, n("onClickSearch", I.value);
    }, E = () => {
      n("onEnterKeyword", g.value);
    }, K = () => {
      n("onFocusInSearch", !0);
    }, x = () => {
      n("onFocusInSearch", !1);
    }, n2 = () => {
      y.value = !y.value;
    }, A2 = (N) => {
      A.value = N, n("onChangeLang", A.value);
    }, u2 = () => {
      L.value = !0, r.value && r.value.classList.remove("opacity");
    }, F2 = (N) => {
      const P = N.relatedTarget, { clientY: Z, clientX: G } = N;
      (P && !P.closest(".amm-sub-menu-section") || Z <= 0 || G <= 0 || G >= window.innerWidth) && (L.value = !1, r.value && r.value.classList.add("opacity"));
    }, I2 = () => {
      if (!h.value)
        n("onClickLogin");
      else {
        const N = s.value.lang, P = C.value.toLowerCase();
        let Z = f0(s.value.env, b.MY) + P;
        switch (C.value) {
          default:
          case b.PLAY:
            Z += "?tab=my-channel";
            break;
          case b.STUDIO:
            Z += "?tab=my-space";
            break;
          case b.ASSET:
            Z += "?tab=download";
            break;
          case b.COMM:
            Z += "?tab=my-post";
            break;
        }
        window.innerWidth < 1280 && (Z += "&home=1"), N && (Z += `&lang=${N}`), Z += `&prev=${P}`, window.location.href = Z;
      }
    }, $ = () => {
      L.value = !L.value;
    }, v2 = (N, P) => {
      if (N.subMenuList.length === 0) {
        a2(f0(s.value.env, N.serviceCode) + `?lang=${A.value}`, P);
        return;
      }
      c.value !== N.serviceCode ? c.value = N.serviceCode : c.value = null;
    }, b2 = () => {
      const N = document.querySelectorAll(".amm-menu-list > li"), P = document.querySelectorAll(".amm-sub-menu-section > ul");
      if (N instanceof NodeList && P instanceof NodeList && N.length === P.length)
        for (let Z = 0; Z < N.length; Z++)
          P[Z].style.width = N[Z].offsetWidth + "px";
    }, a2 = (N, P) => {
      P.ctrlKey || P.metaKey ? window.open(N, "_blank") : window.location.href = N;
    }, D2 = () => {
      n("onClickStudioMake");
    }, Z2 = () => {
      if (!r.value) return;
      let N = window.scrollY;
      N > 0 ? (L.value ? r.value.classList.remove("opacity") : r.value.classList.add("opacity"), N > M.value && x2()) : r.value.classList.remove("opacity"), M.value = N <= 0 ? 0 : N;
    }, x2 = () => {
      var N, P;
      if (((N = s.value) == null ? void 0 : N.serviceType) === b.PLAY) {
        if (!((P = u.value) != null && P.includes("/content")) || !I.value) return;
        S();
      }
    }, L2 = (N) => {
      const P = N.detail;
      P && (I.value = P.data, P.keyword && (g.value = P.keyword), n("onClickSearch", I.value));
    }, d2 = () => {
      n("onClickLogo");
    }, l2 = (N, P) => {
      let Z = f0(s.value.env, N);
      P && (Z += P);
      const G = new URL(Z);
      if (G.hash) {
        const [C2, o] = G.hash.split("?"), l = new URLSearchParams(o || "");
        l.set("lang", A.value), G.hash = `${C2}?${l.toString()}`;
      } else
        G.searchParams.append("lang", A.value);
      return G.toString();
    }, O2 = () => {
      var N, P;
      ((N = s.value) == null ? void 0 : N.serviceType) === b.PLAY && (i.value = !!((P = u.value) != null && P.includes("/content")));
    };
    return $2(
      () => s,
      () => {
        s.value.alwaysSearchbarOpen !== null && s.value.alwaysSearchbarOpen !== void 0 && (I.value = s.value.alwaysSearchbarOpen);
      },
      { deep: !0 }
    ), $2(
      () => u,
      () => {
        O2();
      },
      { deep: !0 }
    ), ge(() => {
      F();
    }), b0(() => {
      if (s.value.serviceUrl) {
        const N = Object.keys(s.value.serviceUrl);
        for (const P of N)
          ue[s.value.env][P] = s.value.serviceUrl[P];
        O2();
      }
      b2(), window.addEventListener("resize", b2), window.addEventListener("scroll", Z2), window.addEventListener(v0.SEARCH_BAR_CONTROLLER, L2), he(() => {
        n("onClickSearch", I.value);
      });
    }), Ae(() => {
      window.removeEventListener("resize", b2), window.removeEventListener("scroll", Z2), window.removeEventListener(v0.SEARCH_BAR_CONTROLLER, L2);
    }), (N, P) => {
      var G, C2, o;
      const Z = ve("click-away");
      return V(), W("header", {
        id: "apoc-mega-menu",
        class: t2((G = s.value.theme) == null ? void 0 : G.toLocaleLowerCase()),
        ref_key: "apocMegaHeader",
        ref: r
      }, [
        T("div", Lt, [
          T("section", kt, [
            O(w)["left-area"] ? (V(), W("div", wt, [
              Y2(N.$slots, "left-area")
            ])) : (V(), W("div", yt, [
              T("li", {
                class: "amm-hamburger-icon",
                onClick: $
              }, [
                T("img", {
                  src: O(Q).hamburger,
                  onClick: f2($, ["self", "stop"]),
                  alt: "hamburger"
                }, null, 8, Mt)
              ]),
              C.value === O(b).APOC ? (V(), W("a", {
                key: 0,
                class: "amm-link apoc",
                onClick: d2
              }, [
                T("img", {
                  src: O(Q).apocLogo,
                  alt: "playLogoPc"
                }, null, 8, St)
              ])) : c2("", !0),
              C.value === O(b).PLAY ? (V(), W("a", {
                key: 1,
                class: "amm-link play",
                onClick: d2
              }, [
                T("img", {
                  src: O(Q).playLogoPc,
                  alt: "playLogoPc",
                  class: "pc"
                }, null, 8, Ft),
                T("img", {
                  src: O(Q).playLogoTb,
                  alt: "playLogoTb",
                  class: "tb"
                }, null, 8, It),
                T("img", {
                  src: O(Q).playLogoMb,
                  alt: "playLogoMb",
                  class: "mb"
                }, null, 8, Ot)
              ])) : C.value === O(b).STUDIO ? (V(), W("a", {
                key: 2,
                class: "amm-link studio",
                onClick: d2
              }, [
                T("img", {
                  src: O(Q).studioLogoPc,
                  alt: "studioLogoPc",
                  class: "pc"
                }, null, 8, Et),
                T("img", {
                  src: O(Q).studioLogoTb,
                  alt: "studioLogoTb",
                  class: "tb"
                }, null, 8, Ht),
                T("img", {
                  src: O(Q).studioLogoMb,
                  alt: "studioLogoMb",
                  class: "mb"
                }, null, 8, Tt)
              ])) : C.value === O(b).ASSET ? (V(), W("a", {
                key: 3,
                class: "amm-link asset",
                onClick: d2
              }, [
                T("img", {
                  src: O(Q).assetLogoPc,
                  alt: "assetLogoPc",
                  class: "pc"
                }, null, 8, Nt),
                T("img", {
                  src: O(Q).assetLogoTb,
                  alt: "assetLogoTb",
                  class: "tb"
                }, null, 8, Pt),
                T("img", {
                  src: O(Q).assetLogoMb,
                  alt: "assetLogoMb",
                  class: "mb"
                }, null, 8, Rt)
              ])) : C.value === O(b).COMM ? (V(), W("a", {
                key: 4,
                class: "amm-link comm",
                onClick: d2
              }, [
                T("img", {
                  src: O(Q).commLogoPc,
                  alt: "commLogoPc",
                  class: "pc"
                }, null, 8, Vt),
                T("img", {
                  src: O(Q).commLogoTb,
                  alt: "commLogoTb",
                  class: "tb"
                }, null, 8, Wt),
                T("img", {
                  src: O(Q).commLogoMb,
                  alt: "commLogoMb",
                  class: "mb"
                }, null, 8, Bt)
              ])) : c2("", !0)
            ]))
          ]),
          T("section", Ut, [
            O(w)["middle-area"] ? (V(), W("div", Dt, [
              Y2(N.$slots, "middle-area")
            ])) : (V(), W("div", Zt, [
              T("ul", {
                class: "amm-menu-list",
                onMouseenter: u2
              }, [
                (V(!0), W(E2, null, H2(O(d0), (l) => (V(), W("li", {
                  class: t2({ active: C.value === l.serviceCode }),
                  key: l.serviceCode
                }, [
                  T("a", {
                    onClick: f2((d) => a2(l2(l.serviceCode), d), ["prevent", "stop"]),
                    role: "link"
                  }, p2(O(v)(l.serviceName)), 9, xt)
                ], 2))), 128))
              ], 32)
            ])),
            o2(j2, { name: "dropdown" }, {
              default: q2(() => {
                var l;
                return [
                  T2(T("section", {
                    class: t2(["amm-sub-menu-section", (l = s.value.theme) == null ? void 0 : l.toLocaleLowerCase()]),
                    onMouseleave: F2
                  }, [
                    (V(!0), W(E2, null, H2(O(d0), (d) => (V(), W("ul", Qt, [
                      (V(!0), W(E2, null, H2(d.subMenuList, (p) => (V(), W("li", {
                        onClick: f2((H) => a2(l2(d.serviceCode, p.subMenuPath), H), ["prevent", "stop"])
                      }, [
                        T("a", {
                          onClick: f2((H) => a2(l2(d.serviceCode, p.subMenuPath), H), ["prevent", "stop"]),
                          role: "link"
                        }, p2(O(v)(p.subMenuName)), 9, Jt)
                      ], 8, Kt))), 256))
                    ]))), 256))
                  ], 34), [
                    [X2, L.value]
                  ])
                ];
              }),
              _: 1
            })
          ]),
          T("section", {
            class: t2(["right-area", (C2 = s.value.theme) == null ? void 0 : C2.toLocaleLowerCase()])
          }, [
            O(w)["right-area"] ? (V(), W("div", Gt, [
              Y2(N.$slots, "right-area")
            ])) : (V(), W("div", Yt, [
              T("ul", null, [
                f.indexOf(C.value) > -1 && !s.value.alwaysSearchbarOpen ? (V(), W("li", {
                  key: 0,
                  class: t2(["amm-search-icon", i.value ? "play-contents" : ""]),
                  onClick: S
                }, [
                  o2(N2, {
                    src: O(Q).search,
                    onClick: f2(S, ["self"])
                  }, null, 8, ["src"])
                ], 2)) : c2("", !0),
                T("li", {
                  class: "amm-lang-change",
                  onClick: n2
                }, [
                  o2(N2, {
                    src: O(Q).language
                  }, null, 8, ["src"]),
                  T("p", null, p2((o = O(T0).find((l) => l.code === A.value)) == null ? void 0 : o.subLabel), 1),
                  o2(j2, { name: "dropdown" }, {
                    default: q2(() => [
                      T2((V(), W("div", jt, [
                        T("ul", qt, [
                          (V(!0), W(E2, null, H2(O(T0), (l) => (V(), W("li", {
                            key: l.code,
                            value: l.code,
                            onClick: (d) => A2(l.code)
                          }, [
                            T("div", zt, [
                              T("span", null, p2(O(v)(l.label)), 1),
                              T2(T("span", null, p2(O(v)(l.subLabel)), 513), [
                                [X2, l.subLabel]
                              ])
                            ]),
                            A.value === l.code ? (V(), W("img", {
                              key: 0,
                              class: "amm-option-list-check",
                              src: O(Q).checkIcon,
                              alt: "user-check-box"
                            }, null, 8, _t)) : c2("", !0)
                          ], 8, Xt))), 128))
                        ])
                      ])), [
                        [X2, y.value],
                        [Z, () => y.value = !1]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                !h.value && C.value !== O(b).APOC && C.value !== O(b).STUDIO ? (V(), W("li", {
                  key: 1,
                  onClick: I2,
                  class: t2(["amm-auth", C.value.toLowerCase()])
                }, P[2] || (P[2] = [
                  T("p", { class: "login-btn" }, " Login ", -1)
                ]), 2)) : h.value && C.value !== O(b).APOC ? (V(), W("li", {
                  key: 2,
                  onClick: I2,
                  class: t2(["amm-auth", C.value.toLowerCase()])
                }, P[3] || (P[3] = [
                  T("p", { class: "login-btn" }, " MY ", -1)
                ]), 2)) : c2("", !0),
                C.value === O(b).STUDIO ? (V(), W("li", {
                  key: 3,
                  class: "amm-studio-make",
                  onClick: D2
                }, p2(O(v)("studio.make")), 1)) : c2("", !0)
              ])
            ]))
          ], 2),
          O(w)["search-area"] ? (V(), W("div", $t, [
            Y2(N.$slots, "search-area")
          ])) : i.value ? (V(), W("section", {
            key: 1,
            class: t2(["amm-search-bar-play-content-wrapper", [C.value.toLowerCase(), { dropdown: I.value }]])
          }, [
            T("div", e3, [
              o2(N2, {
                src: O(Q).barSearch
              }, null, 8, ["src"]),
              T2(T("input", {
                type: "text",
                "onUpdate:modelValue": P[0] || (P[0] = (l) => g.value = l),
                "enter-key-hint": "enter",
                onFocusin: K,
                onFocusout: x,
                onKeyup: E0(E, ["enter"]),
                placeholder: s.value.searchBarPlaceHolder
              }, null, 40, t3), [
                [H0, g.value]
              ])
            ])
          ], 2)) : (V(), W("section", {
            key: 2,
            class: t2(["amm-search-bar-wrapper", [C.value.toLowerCase(), { dropdown: I.value, "play-content": i.value }]])
          }, [
            T("div", n3, [
              o2(N2, {
                src: O(Q).barSearch
              }, null, 8, ["src"]),
              T2(T("input", {
                type: "text",
                "onUpdate:modelValue": P[1] || (P[1] = (l) => g.value = l),
                "enter-key-hint": "enter",
                onFocusin: K,
                onFocusout: x,
                onKeyup: E0(E, ["enter"]),
                placeholder: s.value.searchBarPlaceHolder
              }, null, 40, a3), [
                [H0, g.value]
              ])
            ])
          ], 2))
        ]),
        o2(j2, {
          name: s.value.sideBarLocation === O(L0).LEFT ? "leftslide" : "rightslide"
        }, {
          default: q2(() => {
            var l;
            return [
              T2(T("section", {
                class: t2(["amm-main-menu-section-tablet", [s.value.sideBarLocation, (l = s.value.theme) == null ? void 0 : l.toLocaleLowerCase()]])
              }, [
                T("div", null, [
                  T("ul", null, [
                    T("li", s3, [
                      C.value === O(b).APOC ? (V(), W("a", o3, [
                        T("img", {
                          src: O(Q).apocLogo,
                          alt: "playLogoPc"
                        }, null, 8, r3)
                      ])) : c2("", !0),
                      C.value === O(b).PLAY ? (V(), W("a", l3, [
                        T("img", {
                          src: O(Q).playLogoTb,
                          alt: "playLogoTb",
                          class: "tb"
                        }, null, 8, c3)
                      ])) : C.value === O(b).STUDIO ? (V(), W("a", i3, [
                        T("img", {
                          src: O(Q).studioLogoTb,
                          alt: "studioLogoTb",
                          class: "tb"
                        }, null, 8, u3)
                      ])) : C.value === O(b).ASSET ? (V(), W("a", d3, [
                        T("img", {
                          src: O(Q).assetLogoTb,
                          alt: "assetLogoTb",
                          class: "tb"
                        }, null, 8, f3)
                      ])) : C.value === O(b).COMM ? (V(), W("a", m3, [
                        T("img", {
                          src: O(Q).commLogoTb,
                          alt: "commLogoTb",
                          class: "tb"
                        }, null, 8, C3)
                      ])) : c2("", !0),
                      o2(N2, {
                        src: O(Q).spaceX,
                        onClick: $
                      }, null, 8, ["src"])
                    ]),
                    (V(!0), W(E2, null, H2(O(d0), (d) => (V(), W("div", {
                      class: t2(["amm-menu", { active: c.value === d.serviceCode }])
                    }, [
                      T("div", {
                        onClick: f2((p) => v2(d, p), ["self"])
                      }, [
                        T("a", {
                          onClick: f2((p) => a2(l2(d.serviceCode), p), ["prevent", "stop"]),
                          role: "link"
                        }, p2(O(v)(d.serviceName)), 9, g3),
                        d.subMenuList.length > 0 ? (V(), be(N2, {
                          key: 0,
                          src: O(Q).downArrow,
                          onClick: (p) => v2(d, p),
                          class: t2({ active: c.value === d.serviceCode })
                        }, null, 8, ["src", "onClick", "class"])) : c2("", !0)
                      ], 8, p3),
                      o2(j2, { name: "dropdown" }, {
                        default: q2(() => [
                          c.value === d.serviceCode ? (V(), W("ul", {
                            key: 0,
                            style: Le(`height:${d.subMenuList.length * 47}px`)
                          }, [
                            (V(!0), W(E2, null, H2(d.subMenuList, (p) => (V(), W("li", {
                              onClick: f2((H) => a2(l2(d.serviceCode, p.subMenuPath), H), ["prevent", "stop"])
                            }, [
                              T("a", {
                                onClick: f2((H) => a2(l2(d.serviceCode, p.subMenuPath), H), ["prevent", "stop"]),
                                role: "link"
                              }, p2(O(v)(p.subMenuName)), 9, A3)
                            ], 8, h3))), 256))
                          ], 4)) : c2("", !0)
                        ]),
                        _: 2
                      }, 1024)
                    ], 2))), 256))
                  ])
                ])
              ], 2), [
                [X2, L.value]
              ])
            ];
          }),
          _: 1
        }, 8, ["name"]),
        P[4] || (P[4] = T("div", { class: "fake-shadow-box" }, null, -1))
      ], 2);
    };
  }
}), L3 = {
  install(e) {
    e.component("ApocMegaMenu", v3);
  }
};
export {
  v0 as ApocMegaMenuEvent,
  y2 as ENV,
  e0 as LANG,
  L0 as LOCATION,
  b as SERVICE_TYPE,
  ae as THEME,
  L3 as default,
  ke as delYN
};
//# sourceMappingURL=apoc-mega-menu.es.js.map
